import React from 'react';
import Img from 'react-image';
import Classnames from 'classnames'
import moment from 'moment'
import SVG from 'react-inlinesvg';
import _ from 'lodash'
//AriveeIcon
import srcEnfantAbsent from './styles/img/enfant-absent.svg';
import srcEnfantAttendu from './styles/img/enfant-attendu.svg';
import srcEnfantParti from './styles/img/enfant-parti.svg';
import srcEnfantSortie from './styles/img/icon-enfant-sortie.svg';
import srcEnfantPresent from './styles/img/enfant-present.svg';
import srcEnfantArrive from './styles/img/icon-arrivee.svg';

//Activite et Sante par Défaut
import srcActivite from './styles/img/icon-activite.svg';

//santeIcon
import srcIconFievre from './styles/img/icon-fievre.svg';
import srcIconVomi from './styles/img/icon-vomi.svg';
import srcIconToux from './styles/img/icon-toux.svg';
import srcIconblessure from './styles/img/icon-blessure.svg';
import srcIconBoutons from './styles/img/icon-boutons.svg';
//  ActiviteIcon
import srcIconPateAModule from './styles/img/icon-pate-a-modeler.svg';
import srcIconPienture from './styles/img/icon-peinture.svg';
import srcIconDanse from './styles/img/icon-danse.svg';
import srcIconSortie from './styles/img/icon-sortie.svg';
import srcIconPiscine from './styles/img/icon-piscine.svg';
import srcIconLecture from './styles/img/icon-lecture.svg';
import srcIconActiviteManuelle from './styles/img/icon-activites-manuelles.svg';
import srcIconAutre from './styles/img/icon-autre.svg';

//PetiCoin
import srcIconPetitCoin from './styles/img/icon-petitcoin.svg';

//Sieste
import srcIconSieste from './styles/img/icon-sieste.svg';
//Repas
import srcIconRepas from './styles/img/icon-repas.svg';
import srcIconBiberon from './styles/img/icon-biberon.svg';
//histo medicale
import srcIconHistoriqueMedical from './styles/img/icon-historique-medical.svg';

moment.locale('fr');


export const SVGIcon = (props) => (
  getPath(props)
);

const getPath = (props) => {
  const { size, style, classCSS, name } = props
  switch (name) {
    case "PRESENT":
      return (
        <svg
          width={size} height={size} viewBox="0 0 26 26" fill="#004CC5"
          className={classCSS}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            {...props}
            d="M0.3,14C0.1,13.8,0,13.5,0,13.3s0.1-0.5,0.3-0.7l1.4-1.4c0.4-0.4,1-0.4,1.4,0l0.1,0.1l5.5,5.9
          c0.2,0.2,0.5,0.2,0.7,0L22.8,3.3h0.1l0,0c0.4-0.4,1-0.4,1.4,0l1.4,1.4c0.4,0.4,0.4,1,0,1.4l0,0l-16,16.6C9.5,22.9,9.3,23,9,23
          s-0.5-0.1-0.7-0.3l-7.8-8.4C0.5,14.3,0.3,14,0.3,14z"
          />
        </svg>

      );
    case "ATTENDU":
      return (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width={size} height={size} fill="#999999" viewBox="0 0 47 47" space="preserve">
          <path d="M22.4,22.4c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1c0-1.2,0.4-2.5,1.3-3.4c1.8-2.1,3.1-4.4,4-6.9
				c0.1-0.3,0.1-0.7-0.1-1c-0.2-0.3-0.5-0.5-0.9-0.5H18.2c-0.3,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.2,0.6-0.1,1c0.9,2.4,2.2,4.7,4,6.9
				C22,20,22.4,21.2,22.4,22.4z"/>
          <path d="M24.6,26.7c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1c0,1.5-0.9,3.1-2.6,4.3c-3.6,2.6-6.2,5.5-8,8.5
				c-0.2,0.3-0.2,0.7,0,1.1c0.2,0.3,0.5,0.5,0.9,0.5h21.4c0.4,0,0.7-0.2,0.9-0.5c0.2-0.3,0.2-0.7,0-1.1c-1.7-3-4.4-5.9-8-8.5
				C25.5,29.8,24.6,28.3,24.6,26.7z"/>
          <path d="M42.2,42.7h-0.6C40.8,34.4,36,28,32.2,23.5C36,19,40.8,12.6,41.6,4.3h0.6c1.2,0,2.1-1,2.1-2.1
				c0-1.2-1-2.1-2.1-2.1H4.8C3.6,0,2.7,1,2.7,2.1c0,1.2,1,2.1,2.1,2.1h0.6C6.2,12.6,11,19,14.8,23.5C11,28,6.2,34.4,5.4,42.7H4.8
				c-1.2,0-2.1,1-2.1,2.1c0,1.2,1,2.1,2.1,2.1h2.7h32h2.7c1.2,0,2.1-1,2.1-2.1C44.3,43.7,43.4,42.7,42.2,42.7z M9.7,42.7
				c0.8-7.5,5.7-13.3,9.3-17.6l0.2-0.2c0.7-0.8,0.7-2,0-2.8l-0.2-0.2c-3.6-4.3-8.5-10.1-9.3-17.6h27.5c-0.8,7.5-5.7,13.3-9.3,17.6
				l-0.2,0.2c-0.7,0.8-0.7,2,0,2.8l0.2,0.2c3.6,4.3,8.5,10.1,9.3,17.6C37.3,42.7,9.7,42.7,9.7,42.7z"/>
        </svg>
      );
    case "PARTI":
      return (
        <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width={size} height={size} fill="#8B00C5" viewBox="0 0 512 512" space="preserve">
          <path d="M496,240H293.3c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16H496c8.8,0,16,7.2,16,16C512,232.8,504.8,240,496,240z"
          />
          <path d="M416,320c-4.1,0-8.2-1.6-11.3-4.7c-6.2-6.3-6.2-16.4,0-22.6l68.7-68.7l-68.7-68.7c-6.2-6.2-6.2-16.4,0-22.6
	c6.3-6.3,16.4-6.3,22.6,0l80,80c6.2,6.2,6.2,16.4,0,22.6l-80,80C424.2,318.4,420.1,320,416,320z"/>
          <path d="M170.7,512c-4.6,0-8.9-0.6-13.2-2L29.1,467.2C11.6,461.1,0,444.9,0,426.7v-384C0,19.2,19.1,0,42.7,0
	c4.6,0,8.9,0.6,13.2,2l128.4,42.8c17.5,6.1,29.1,22.4,29.1,40.6v384C213.3,492.9,194.2,512,170.7,512z M42.7,32
	C36.8,32,32,36.8,32,42.7v384c0,4.5,3.1,8.8,7.4,10.3l127.8,42.6c0.9,0.3,2.1,0.5,3.5,0.5c5.9,0,10.7-4.8,10.7-10.7v-384
	c0-4.5-3.1-8.8-7.4-10.3L46.1,32.5C45.2,32.2,44,32,42.7,32z"/>
          <path d="M325.3,170.7c-8.8,0-16-7.2-16-16v-96c0-14.7-12-26.7-26.7-26.7h-240c-8.8,0-16-7.2-16-16s7.2-16,16-16h240
	c32.4,0,58.7,26.3,58.7,58.7v96C341.3,163.5,334.2,170.7,325.3,170.7z"/>
          <path d="M282.7,448h-85.3c-8.8,0-16-7.2-16-16s7.2-16,16-16h85.3c14.7,0,26.7-12,26.7-26.7v-96c0-8.8,7.2-16,16-16
	s16,7.2,16,16v96C341.3,421.7,315,448,282.7,448z"/>
        </svg>
      );
    case "ABSENT":
      return (
        <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width={size} height={size} fill="#ff7d26" viewBox="0 0 50 50" space="preserve">
          <path d="M45.7,6.5h-8.6V4.8c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.7H15.6V4.8c0-0.7-0.6-1.3-1.3-1.3
	c-0.7,0-1.3,0.6-1.3,1.3v1.7H4.3C3.6,6.5,3,7.1,3,7.9v37.8C3,46.4,3.6,47,4.3,47h41.4c0.7,0,1.3-0.6,1.3-1.3c0-1.2,0-37.2,0-37.8
	C47.1,7.1,46.5,6.5,45.7,6.5z M44.4,44.3H5.7V18.9h38.8V44.3z M44.4,16.2H5.7v-7H13v1.7c0,0.7,0.6,1.3,1.3,1.3
	c0.7,0,1.3-0.6,1.3-1.3V9.2h18.8v1.7c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3V9.2h7.3V16.2z"/>
          <path d="M17,39.7c0.5,0.5,1.4,0.5,1.9,0l6.1-6.1l6.1,6.1c0.5,0.5,1.4,0.5,1.9,0c0.5-0.5,0.5-1.4,0-1.9l-6.1-6.1l6.1-6.1
	c0.5-0.5,0.5-1.4,0-1.9c-0.5-0.5-1.4-0.5-1.9,0L25,29.8l-6.1-6.1c-0.5-0.5-1.4-0.5-1.9,0c-0.5,0.5-0.5,1.4,0,1.9l6.1,6.1L17,37.9
	C16.5,38.4,16.5,39.2,17,39.7z"/>
        </svg>
      );
    case "ARRIVEE":
      return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width={size} height={size} fill="#004CC5" viewBox="0 0 512 512" space="preserve">
          <path d="M270.9,283.3c0-7.4,6.1-13.5,13.5-13.5h170.5c7.4,0,13.5,6.1,13.5,13.5s-6.1,13.5-13.5,13.5H284.4
	C277,296.7,270.9,290.8,270.9,283.3z"/>
          <path d="M342.2,360.1l-67.3-67.3c-5.2-5.2-5.2-13.8,0-19l67.3-67.3c5.2-5.3,13.7-5.3,19,0c5.2,5.2,5.2,13.8,0,19
	l-57.8,57.8l57.7,57.8c5.2,5.2,5.2,13.7,0,19c-2.6,2.6-6.1,4-9.5,4C348.2,364,344.8,362.8,342.2,360.1z"/>
          <path d="M217.2,76.8v323c0,15.3-9.8,29-24.5,34.2l-108,36c-3.6,1.2-7.2,1.7-11.1,1.7c-19.9,0-35.9-16.2-35.9-35.9v-323
	c0-15.3,9.8-28.9,24.5-34.1l108-36c3.6-1.2,7.2-1.7,11.1-1.7C201,41,217.1,57.1,217.2,76.8z M76.4,444.4L184,408.5
	c3.6-1.3,6.2-4.9,6.2-8.7v-323c0-5-4-9-9-9c-1.2,0-2.2,0.2-2.9,0.4L70.8,104.1c-3.6,1.3-6.2,4.9-6.2,8.7v323c0,5,4,9,9,9
	C74.6,444.8,75.7,444.6,76.4,444.4z"/>
          <path d="M324.7,374.1v60.6c0,20.4-22.1,37-49.4,37H73.5c-7.4,0-13.5-4.5-13.5-10.1s6.1-10.1,13.5-10.1h201.9
	c12.4,0,22.5-7.6,22.5-16.8v-60.6c0-5.6,6.1-10.1,13.5-10.1C318.8,364,324.7,368.6,324.7,374.1z"/>
          <path d="M324.8,131.9v60.6c0,5.6-6.1,10.1-13.5,10.1s-13.5-4.5-13.5-10.1v-60.6c0-9.3-10.1-16.8-22.5-16.8h-71.8
	c-7.4,0-13.5-4.5-13.5-10.1c0-5.6,6.1-10.1,13.5-10.1h71.8C302.6,94.8,324.7,111.4,324.8,131.9z"/>
        </svg>
      );
    case "DEPART":
      return (
        <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width={size} height={size} fill="#0B45EF" viewBox="0 0 50 50" space="preserve">
          <path d="M47.6,9.5c-2.9-2.9-8.2-5-11.8-6c-2.9-0.8-6.1-1.2-8.8-1.2c-1.7,0-3.2,0.2-4.5,0.5c-0.3,0.1-0.6,0.3-0.6,0.6
			c-0.3,1-0.5,2-0.7,3.1c0,0,0,0.1,0,0.1c-0.7,4.2-0.9,8.7-0.4,12.6c-2.3,0.1-4.7,0.5-6.9,1.1c-3.7,1-9,3.1-11.8,6
			c-0.2,0.2-0.3,0.6-0.2,0.9c0.3,1.1,0.6,2.2,1,3.3c0,0,0,0,0,0c1.4,3.8,3.4,7.6,5.7,10.6c2.5,3.3,6.4,7.2,10.9,7.2
			c0.6,0,1.3-0.1,1.9-0.3c2.7-0.7,4.9-3,6.2-6.6c1-2.7,1.6-6.2,1.6-10c0.4,0.1,0.7,0.1,1.1,0.1c4.5,0,8.4-3.9,10.9-7.2
			c2.9-3.9,5.5-9.1,6.7-13.9C47.9,10.1,47.8,9.8,47.6,9.5z M20.9,46.4c-0.5,0.1-1,0.2-1.4,0.2c-2.9,0-6.3-2.3-9.4-6.5
			c-2.1-2.8-3.9-6.2-5.2-9.6c0.5-0.4,1.3-1,2.1-1.5c0.4-0.3,0.5-0.8,0.2-1.2c-0.3-0.4-0.8-0.5-1.2-0.2c-0.6,0.4-1.2,0.9-1.7,1.2
			c-0.2-0.5-0.3-0.9-0.4-1.4c2.2-2,6.4-4.1,10.7-5.2c2.2-0.6,4.5-1,6.7-1.1c0.3,1.5,0.7,2.9,1.2,4.1c0,0,0,0,0,0
			c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0.2,0.6,0.5,1.1,0.8,1.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2
			c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0.1,0.1,0.1
			c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0.1,0.2,0.3,0.4,0.4c-0.5,0.7-1.4,1.1-2.3,1.1c-1,0-2-0.6-2.5-1.4
			c-0.2-0.4-0.8-0.6-1.2-0.3c-0.4,0.2-0.6,0.8-0.3,1.2c0.8,1.4,2.4,2.3,4.1,2.3c1.4,0,2.7-0.6,3.6-1.7c0.3,0.2,0.6,0.4,0.9,0.6
			c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0C27.4,37.7,25.7,45.1,20.9,46.4z M39.7,23.2
			c-3.1,4.2-6.5,6.5-9.4,6.5c-0.5,0-1-0.1-1.4-0.2c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0c-3.9-1.3-5.3-6.5-5.8-9.5c0,0,0,0,0,0
			c0-0.1,0-0.1,0-0.2c-0.6-3.7-0.5-8.1,0.1-12.2c0.6-0.1,1.6-0.2,2.5-0.3c0.5,0,0.9-0.5,0.8-1c0-0.5-0.5-0.9-1-0.8
			c-0.7,0.1-1.5,0.1-2.1,0.2c0.1-0.4,0.2-0.8,0.3-1.2c1-0.2,2.2-0.3,3.5-0.3c2.6,0,5.6,0.4,8.3,1.1c4.2,1.1,8.4,3.2,10.7,5.2
			C44.7,14.9,42.4,19.6,39.7,23.2z"/>
        </svg>
      );
    default:
      return <path />;
  }
};


/**
 * 
 * @LES_ICONES_SVG
 */

export const EnfantEventSante = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" space="preserve">
  <path d="M32.2,23.4C32.2,23.4,32.2,23.4,32.2,23.4h-3.6v-3.6c0-0.7-0.6-1.3-1.3-1.3c0,0,0,0,0,0h-5.1
   c-0.7,0-1.3,0.6-1.3,1.3v3.6h-3.5c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0v5.1c0,0.7,0.6,1.3,1.3,1.3H21v3.5c0,0.7,0.6,1.3,1.3,1.3
   c0,0,0,0,0,0h5.1c0.7,0,1.3-0.6,1.3-1.3l0,0v-3.6h3.6c0.7,0,1.3-0.6,1.3-1.3c0,0,0,0,0,0v-5.1C33.5,24,33,23.4,32.2,23.4z
    M31.8,29.4h-4c-0.5,0-0.9,0.4-0.9,0.9v4h-4.2v-4c0-0.5-0.4-0.9-0.9-0.9h-4v-4.2h4c0.5,0,0.9-0.4,0.9-0.9v-4h4.2v4
   c0,0.5,0.4,0.9,0.9,0.9h4V29.4z"/>
  <path d="M40,12.1L40,12.1h-7.2V9c0-1.4-1.1-2.6-2.5-2.6c-0.1,0-0.1,0-0.2,0H19.5c-1.4-0.1-2.6,1-2.7,2.4
   c0,0.1,0,0.1,0,0.2v3H9.7c-2.8,0-6,1.6-6,6V37c0,4.4,3.2,6,6,6H40c2.8,0,6-1.6,6-6V18.1C46,13.6,42.8,12.1,40,12.1z M18.6,9
   c0-0.3,0-0.9,0.9-0.9h10.6c0.9,0,0.9,0.7,0.9,0.9v3H18.6V9z M44.3,37c0,3.8-3,4.3-4.3,4.3H9.7c-1.3,0-4.3-0.4-4.3-4.3V18.1
   c0-3.8,3-4.3,4.3-4.3H40c1.3,0,4.3,0.4,4.3,4.3L44.3,37L44.3,37z"/>
</svg>
)
//Sieste
export const EnfantSieste = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M39.9,45.4l-3.4-7.2c3.4-3.2,5.3-7.6,5.3-12.2c0-9.3-7.6-16.9-16.9-16.9C15.7,9.1,8.1,16.7,8.1,26
   c0,4.6,1.9,9.1,5.3,12.3l-3.3,7.1c-0.3,0.6,0,1.3,0.5,1.5c0.6,0.3,1.3,0,1.5-0.5c0,0,0,0,0,0l3.1-6.6c5.9,4.2,13.7,4.2,19.6,0
   l3,6.6c0.3,0.6,0.9,0.8,1.5,0.6C39.9,46.6,40.2,46,39.9,45.4C39.9,45.4,39.9,45.4,39.9,45.4z M25,40.6c-8.1,0-14.6-6.5-14.6-14.6
   c0-8.1,6.5-14.6,14.6-14.6S39.6,17.9,39.6,26S33,40.6,25,40.6z"/>
  <path d="M33,34l-6.9-8.4v-8.7c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1V26c0,0.3,0.1,0.5,0.3,0.7l7.2,8.7
   c0.4,0.5,1.1,0.6,1.6,0.1S33.4,34.5,33,34z"/>
  <path d="M19,7.7c-2.9-4.3-8.7-5.4-12.9-2.5s-5.4,8.7-2.5,12.9c0.6,0.9,1.3,1.6,2.1,2.2c0.5,0.4,1.2,0.3,1.6-0.2
   c0.4-0.5,0.3-1.2-0.2-1.6C4,16.2,3.4,11.7,5.7,8.7C7,6.9,9.1,5.8,11.3,5.8c2.3,0,4.5,1.2,5.8,3.1c0.4,0.5,1.1,0.7,1.6,0.3
   C19.2,8.9,19.4,8.2,19,7.7z"/>
  <path d="M46.2,7.3c-3.1-4.1-8.9-5-13-2c-0.9,0.7-1.6,1.5-2.3,2.4c-0.4,0.5-0.2,1.2,0.3,1.6c0.5,0.3,1.2,0.2,1.6-0.3
   c2.1-3.2,6.5-4.1,9.7-2c3.2,2.1,4.1,6.5,2,9.7c-0.5,0.7-1,1.3-1.7,1.8l0,0c-0.5,0.4-0.6,1.1-0.2,1.6c0.4,0.5,1.1,0.6,1.6,0.2
   C48.4,17.3,49.2,11.4,46.2,7.3z"/>
</svg>)

//PetitCoin
export const EnfantPetitCoin = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M41.5,20.3H20.7V6.8c0-1.6-1.3-2.8-2.8-2.8h-4.2V2.9c0-0.5-0.4-0.8-0.8-0.8C12.4,2,12,2.4,12,2.9V4H7.8
   C6.3,4,5,5.3,5,6.8v13.8c0,2.7,2.2,4.9,4.9,4.9h1.4v5.6c0,2.3,1.7,4.3,3.9,4.7v10.7c0,0.5,0.4,0.8,0.8,0.8h15.7
   c0.5,0,0.8-0.4,0.8-0.8v-8.3c5.5-0.4,9.8-5,9.8-10.6v-2.2c1.1-0.3,1.8-1.3,1.8-2.5C44.1,21.5,43,20.3,41.5,20.3z M6.6,6.8
   c0-0.7,0.5-1.2,1.2-1.2h10.1c0.7,0,1.2,0.5,1.2,1.2v0.4H6.6V6.8z M9.9,23.9c-1.8,0-3.2-1.5-3.2-3.2V8.9h12.4v15H9.9z M31.7,36.6
   h-6.2c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h5.4v7.5H16.8V35.1c0-0.5-0.4-0.8-0.8-0.8c-1.7,0-3.1-1.4-3.1-3.1v-5.6h27.8v2
   h0C40.7,32.6,36.6,36.6,31.7,36.6z M41.5,23.9H20.7v-2h20.8c0.6,0,1,0.5,1,1C42.5,23.5,42.1,23.9,41.5,23.9z"/>
</svg>
)
//Repas
export const EnfantRepas = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M16.5,18.5c-0.4-0.1-0.7,0.1-0.8,0.5c-0.1,0.6-0.4,1.1-0.8,1.5c-1.4,1.4-3.8,1.1-5.4-0.5
     c-0.9-0.9-1.7-2.3-2.1-3.7C7,14.9,7,13.8,7.6,13.2c1.2-1.2,5,0.1,6.8,1.9c0.5,0.5,0.8,1,1.1,1.6c0.1,0.3,0.5,0.5,0.9,0.4
     c0.3-0.1,0.5-0.5,0.4-0.9c-0.3-0.8-0.8-1.4-1.4-2c-1-1-2.7-2-4.3-2.4c-2-0.6-3.5-0.4-4.5,0.5s-1.1,2.5-0.5,4.5
     C6.6,18.3,7.5,20,8.6,21c1.2,1.2,2.7,1.8,4.1,1.8c1.2,0,2.4-0.4,3.2-1.3c0.6-0.6,1-1.3,1.2-2.1C17.1,19,16.9,18.6,16.5,18.5z"/>
  <path d="M47.4,15c-0.8-0.7-2.1-0.7-2.9,0.1l-6.1,6.1c-0.3,0.3-0.8,0.3-1.1,0c-0.3-0.3-0.3-0.8,0-1.1l6.2-6.2
     c0.8-0.8,0.8-2.1,0-2.9c-0.8-0.8-2.1-0.8-2.9,0l-6.2,6.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2
     c-0.3-0.3-0.3-0.8,0-1.1l6.2-6.2c0.4-0.4,0.6-0.9,0.6-1.5c0-0.5-0.2-1.1-0.6-1.5c-0.8-0.8-2.1-0.8-2.9,0l-1.7,1.7
     c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0l1.7-1.7C37.7,8,37.9,7.9,38,7.9l0,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5
     c0,0.2-0.1,0.4-0.2,0.5l-6.2,6.2c-0.8,0.8-0.8,2.1,0,3c0.4,0.4,0.9,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6l6.2-6.2
     c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1l-6.2,6.2c-0.8,0.8-0.8,2.1,0,3c0.8,0.8,2.1,0.8,3,0l6.1-6.1c0.3-0.3,0.7-0.3,1-0.1
     c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5l-7.2,7.2c-2.4,2.4-5.9,3.1-8.5,1.8c-0.3-0.1-0.6-0.1-0.8,0.2l-9.4,10.6
     c-0.2,0.3-0.2,0.7,0.1,1c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.4-0.1,0.5-0.2l2.7-3.1l7.1,8c0.7,0.8,1.7,1.3,2.8,1.3c0,0,0.1,0,0.1,0
     c1.1,0,2-0.4,2.8-1.2c0.8-0.8,1.2-1.8,1.2-2.9c0-1.1-0.5-2.1-1.3-2.8l-8.3-7.3l2-2.2c3,1.3,6.9,0.4,9.5-2.3l7.2-7.2
     c0.4-0.4,0.6-0.9,0.6-1.5C48,16,47.8,15.4,47.4,15z M36.1,38c0.5,0.5,0.8,1.1,0.9,1.9c0,0.7-0.3,1.4-0.8,1.9
     c-0.5,0.5-1.2,0.8-1.9,0.8c-0.7,0-1.4-0.3-1.9-0.9l-7.2-8.1l2.6-2.9L36.1,38z"/>
  <path d="M19.3,39.4c-0.3-0.2-0.7-0.2-1,0.1l-2.1,2.4c-0.4,0.5-1.1,0.8-1.8,0.8c-0.7,0-1.3-0.2-1.7-0.7
     c-0.5-0.5-0.7-1.1-0.7-1.8s0.3-1.3,0.8-1.7l15.7-13.9c0.2-0.2,0.3-0.5,0.2-0.8c-1.3-2.6-0.6-6.1,1.8-8.5l3.7-3.7
     c0.3-0.3,0.3-0.7,0-1c-0.3-0.3-0.7-0.3-1,0l-3.7,3.7c-2.7,2.7-3.6,6.5-2.3,9.5l-2.5,2.2l-4-3.6c1.4-3.2,0.5-7.3-2.4-10.2
     c-1.8-1.8-4.6-3.4-7.4-4.2c-3.3-1-6-0.7-7.5,0.8c-1.5,1.5-1.8,4.2-0.8,7.5c0.8,2.8,2.4,5.6,4.2,7.4c2.8,2.8,6.9,3.8,10.2,2.4
     l3.3,3.8l-8.4,7.5c-0.8,0.7-1.2,1.7-1.3,2.7c0,1,0.4,2,1.1,2.8c0.7,0.7,1.6,1.1,2.6,1.1c0,0,0.1,0,0.1,0c1,0,2-0.5,2.7-1.3
     l2.1-2.4C19.6,40,19.5,39.6,19.3,39.4z M17.6,25c-0.2-0.2-0.5-0.3-0.8-0.2c-2.8,1.4-6.5,0.7-9.1-1.9c-1.6-1.6-3.1-4.3-3.9-6.9
     c-0.8-2.8-0.6-5,0.5-6.1s3.4-1.3,6.1-0.5c2.6,0.8,5.3,2.3,6.9,3.9c2.6,2.6,3.4,6.3,1.9,9.1c-0.1,0.3-0.1,0.6,0.2,0.8l4.3,3.8
     l-2.4,2.1L17.6,25z"/>
</svg>
)
export const EnfantBiberon = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M15,42.2c0,2.3,1.9,4.2,4.2,4.2h11.7c2.3,0,4.2-1.9,4.2-4.2V22.8c0-1.7-1-3.1-2.4-3.8c0.5-0.6,0.7-1.3,0.7-2.1
c0-1.2-0.7-2.3-1.7-2.9c0-0.2,0-0.4,0-0.4c0-1.5-1-2.4-1.9-3.1c-1.1-0.9-2.3-1.9-2.3-4.4v0c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5
c0,2.5-1.2,3.5-2.3,4.4c-0.9,0.7-1.9,1.6-1.9,3.1c0,0,0,0.2,0,0.4c-1,0.6-1.7,1.7-1.7,2.9c0,0.8,0.3,1.5,0.7,2.1
C16,19.7,15,21.2,15,22.8v6.1c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-6.1c0-1.4,1.1-2.5,2.5-2.5h11.7c1.4,0,2.5,1.1,2.5,2.5v1.3
h-4.2c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h4.2v3.3h-4.2c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h4.2v3.3h-4.2
c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h4.2v3.3h-4.2c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h4.2v1.3c0,1.4-1.1,2.5-2.5,2.5H19.2
c-1.4,0-2.5-1.1-2.5-2.5v-6.6c0-0.5-0.4-0.8-0.8-0.8S15,35.1,15,35.6V42.2z M21.3,11.9c1.2-1,2.9-2.4,2.9-5.7c0-0.5,0.4-0.8,0.8-0.8
s0.8,0.4,0.8,0.8v0c0,3.3,1.7,4.6,2.9,5.6c0.9,0.7,1.3,1.1,1.3,1.8H20C20,13,20.4,12.6,21.3,11.9z M20,15.3h10
c0.9,0,1.7,0.7,1.7,1.7c0,0.9-0.7,1.7-1.7,1.7H20c-0.9,0-1.7-0.7-1.7-1.7C18.3,16.1,19.1,15.3,20,15.3z"/>
  <path d="M15.8,33.1c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8S15.4,33.1,15.8,33.1z" />
</svg>
)

export const EnfantSortie = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M47.6,9.5c-2.9-2.9-8.2-5-11.8-6c-2.9-0.8-6.1-1.2-8.8-1.2c-1.7,0-3.2,0.2-4.5,0.5c-0.3,0.1-0.6,0.3-0.6,0.6
			c-0.3,1-0.5,2-0.7,3.1c0,0,0,0.1,0,0.1c-0.7,4.2-0.9,8.7-0.4,12.6c-2.3,0.1-4.7,0.5-6.9,1.1c-3.7,1-9,3.1-11.8,6
			c-0.2,0.2-0.3,0.6-0.2,0.9c0.3,1.1,0.6,2.2,1,3.3c0,0,0,0,0,0c1.4,3.8,3.4,7.6,5.7,10.6c2.5,3.3,6.4,7.2,10.9,7.2
			c0.6,0,1.3-0.1,1.9-0.3c2.7-0.7,4.9-3,6.2-6.6c1-2.7,1.6-6.2,1.6-10c0.4,0.1,0.7,0.1,1.1,0.1c4.5,0,8.4-3.9,10.9-7.2
			c2.9-3.9,5.5-9.1,6.7-13.9C47.9,10.1,47.8,9.8,47.6,9.5z M20.9,46.4c-0.5,0.1-1,0.2-1.4,0.2c-2.9,0-6.3-2.3-9.4-6.5
			c-2.1-2.8-3.9-6.2-5.2-9.6c0.5-0.4,1.3-1,2.1-1.5c0.4-0.3,0.5-0.8,0.2-1.2c-0.3-0.4-0.8-0.5-1.2-0.2c-0.6,0.4-1.2,0.9-1.7,1.2
			c-0.2-0.5-0.3-0.9-0.4-1.4c2.2-2,6.4-4.1,10.7-5.2c2.2-0.6,4.5-1,6.7-1.1c0.3,1.5,0.7,2.9,1.2,4.1c0,0,0,0,0,0
			c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0.2,0.6,0.5,1.1,0.8,1.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2
			c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0.1,0.1,0.1
			c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0.1,0.2,0.3,0.4,0.4c-0.5,0.7-1.4,1.1-2.3,1.1c-1,0-2-0.6-2.5-1.4
			c-0.2-0.4-0.8-0.6-1.2-0.3c-0.4,0.2-0.6,0.8-0.3,1.2c0.8,1.4,2.4,2.3,4.1,2.3c1.4,0,2.7-0.6,3.6-1.7c0.3,0.2,0.6,0.4,0.9,0.6
			c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0C27.4,37.7,25.7,45.1,20.9,46.4z M39.7,23.2
			c-3.1,4.2-6.5,6.5-9.4,6.5c-0.5,0-1-0.1-1.4-0.2c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0c-3.9-1.3-5.3-6.5-5.8-9.5c0,0,0,0,0,0
			c0-0.1,0-0.1,0-0.2c-0.6-3.7-0.5-8.1,0.1-12.2c0.6-0.1,1.6-0.2,2.5-0.3c0.5,0,0.9-0.5,0.8-1c0-0.5-0.5-0.9-1-0.8
			c-0.7,0.1-1.5,0.1-2.1,0.2c0.1-0.4,0.2-0.8,0.3-1.2c1-0.2,2.2-0.3,3.5-0.3c2.6,0,5.6,0.4,8.3,1.1c4.2,1.1,8.4,3.2,10.7,5.2
			C44.7,14.9,42.4,19.6,39.7,23.2z"/>
  <path d="M42,16.3c-0.8-1.4-2.4-2.3-4.1-2.3s-3.2,0.9-4.1,2.3c-0.2,0.4-0.1,1,0.3,1.2c0.4,0.2,1,0.1,1.2-0.3
			c0.5-0.9,1.5-1.4,2.5-1.4s2,0.6,2.5,1.4c0.2,0.3,0.5,0.5,0.8,0.5c0.2,0,0.3,0,0.4-0.1C42.1,17.2,42.2,16.7,42,16.3z"/>
  <path d="M28.6,11.3c-1.4-0.8-3.2-0.8-4.7,0c-0.4,0.2-0.6,0.8-0.3,1.2c0.2,0.4,0.8,0.6,1.2,0.3c0.9-0.5,2-0.5,2.9,0
			c0.9,0.5,1.4,1.5,1.4,2.5c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9C30.9,13.7,30,12.1,28.6,11.3z"/>
  <path d="M34.5,22.7c-0.4-0.4-0.9-0.4-1.3,0c-0.7,0.7-1.8,1-2.8,0.7c-1-0.3-1.8-1-2-2c-0.1-0.5-0.6-0.8-1.1-0.6
			c-0.5,0.1-0.8,0.6-0.6,1.1c0.4,1.6,1.7,2.9,3.3,3.3c0.4,0.1,0.8,0.2,1.2,0.2c1.2,0,2.4-0.5,3.3-1.4C34.8,23.7,34.8,23.1,34.5,22.7
			z"/>
  <path d="M13.8,29.4L13.8,29.4c-0.5,0-0.9,0.4-0.9,0.9c0,1-0.6,2-1.4,2.5c-0.9,0.5-2,0.5-2.9,0c-0.4-0.2-1-0.1-1.2,0.3
			c-0.2,0.4-0.1,1,0.3,1.2C8.4,34.8,9.2,35,10,35c0.8,0,1.6-0.2,2.3-0.6c1.4-0.8,2.3-2.4,2.3-4.1C14.7,29.8,14.3,29.4,13.8,29.4z"/>
  <path d="M23.3,39.7c-1.2-1.2-2.9-1.6-4.5-1.2c-1.6,0.4-2.9,1.7-3.3,3.3c-0.1,0.5,0.2,1,0.6,1.1c0.1,0,0.2,0,0.2,0
			c0.4,0,0.8-0.3,0.9-0.7c0.3-1,1-1.8,2-2c1-0.3,2.1,0,2.8,0.7c0.4,0.4,0.9,0.4,1.3,0C23.6,40.6,23.6,40.1,23.3,39.7z"/>
  <path d="M28.1,5.5C28.1,5.5,28,5.5,28.1,5.5c-0.6-0.1-1,0.3-1.1,0.7c-0.1,0.5,0.3,0.9,0.8,1l0,0c0,0,0.1,0,0.1,0
			c0.4,0,0.8-0.3,0.9-0.8C28.9,6,28.6,5.6,28.1,5.5z"/>
  <path d="M9.5,26.6c-0.2-0.5-0.7-0.7-1.2-0.5c0,0,0,0-0.1,0c-0.5,0.2-0.7,0.7-0.5,1.2c0.1,0.4,0.5,0.6,0.8,0.6
			c0.1,0,0.2,0,0.3-0.1l0,0C9.4,27.6,9.6,27.1,9.5,26.6z"/>
</svg>)


export const EnfantParti = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} fill="#0B45EF" height={height} viewBox="0 0 512 512" pace="preserve">
  <path d="M235.1,229.4c0,7.4-6.1,13.5-13.5,13.5H51.1c-7.4,0-13.5-6.1-13.5-13.5c0-7.4,6.1-13.5,13.5-13.5h170.5
	C229,216,235.1,222,235.1,229.4z"/>
  <path d="M163.7,152.6l67.3,67.3c5.2,5.2,5.2,13.8,0,19l-67.3,67.3c-5.2,5.3-13.7,5.3-19,0c-5.2-5.2-5.2-13.8,0-19
	l57.8-57.8l-57.7-57.8c-5.2-5.2-5.2-13.7,0-19c2.6-2.6,6.1-4,9.5-4C157.8,148.7,161.2,149.9,163.7,152.6z"/>
  <path d="M288.8,435.9v-323c0-15.3,9.8-29,24.5-34.2l108-36c3.6-1.2,7.2-1.7,11.1-1.7c19.9,0,35.9,16.2,35.9,35.9v323
	c0,15.3-9.8,28.9-24.5,34.1l-108,36c-3.6,1.2-7.2,1.7-11.1,1.7C305,471.7,288.9,455.7,288.8,435.9z M429.6,68.3L322,104.2
	c-3.6,1.3-6.2,4.9-6.2,8.7v323c0,5,4,9,9,9c1.2,0,2.2-0.2,2.9-0.4l107.5-35.8c3.6-1.3,6.2-4.9,6.2-8.7v-323c0-5-4-9-9-9
	C431.3,67.9,430.3,68.1,429.6,68.3z"/>
  <path d="M181.2,138.6V78c0-20.4,22.1-37,49.4-37h201.9c7.4,0,13.5,4.5,13.5,10.1s-6.1,10.1-13.5,10.1H230.6
	c-12.4,0-22.5,7.6-22.5,16.8v60.6c0,5.6-6.1,10.1-13.5,10.1C187.2,148.7,181.2,144.1,181.2,138.6z"/>
  <path d="M181.1,380.9v-60.6c0-5.6,6.1-10.1,13.5-10.1c7.4,0,13.5,4.5,13.5,10.1v60.6c0,9.3,10.1,16.8,22.5,16.8h71.8
	c7.4,0,13.5,4.5,13.5,10.1c0,5.6-6.1,10.1-13.5,10.1h-71.8C203.4,417.9,181.2,401.3,181.1,380.9z"/>
</svg>)
export const EnfantArrive = ({ width, height, classCSS }) => (<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} fill="#0B45EF" height={height} fill="#004CC5" viewBox="0 0 512 512" space="preserve">
  <path d="M270.9,283.3c0-7.4,6.1-13.5,13.5-13.5h170.5c7.4,0,13.5,6.1,13.5,13.5s-6.1,13.5-13.5,13.5H284.4
C277,296.7,270.9,290.8,270.9,283.3z"/>
  <path d="M342.2,360.1l-67.3-67.3c-5.2-5.2-5.2-13.8,0-19l67.3-67.3c5.2-5.3,13.7-5.3,19,0c5.2,5.2,5.2,13.8,0,19
l-57.8,57.8l57.7,57.8c5.2,5.2,5.2,13.7,0,19c-2.6,2.6-6.1,4-9.5,4C348.2,364,344.8,362.8,342.2,360.1z"/>
  <path d="M217.2,76.8v323c0,15.3-9.8,29-24.5,34.2l-108,36c-3.6,1.2-7.2,1.7-11.1,1.7c-19.9,0-35.9-16.2-35.9-35.9v-323
c0-15.3,9.8-28.9,24.5-34.1l108-36c3.6-1.2,7.2-1.7,11.1-1.7C201,41,217.1,57.1,217.2,76.8z M76.4,444.4L184,408.5
c3.6-1.3,6.2-4.9,6.2-8.7v-323c0-5-4-9-9-9c-1.2,0-2.2,0.2-2.9,0.4L70.8,104.1c-3.6,1.3-6.2,4.9-6.2,8.7v323c0,5,4,9,9,9
C74.6,444.8,75.7,444.6,76.4,444.4z"/>
  <path d="M324.7,374.1v60.6c0,20.4-22.1,37-49.4,37H73.5c-7.4,0-13.5-4.5-13.5-10.1s6.1-10.1,13.5-10.1h201.9
c12.4,0,22.5-7.6,22.5-16.8v-60.6c0-5.6,6.1-10.1,13.5-10.1C318.8,364,324.7,368.6,324.7,374.1z"/>
  <path d="M324.8,131.9v60.6c0,5.6-6.1,10.1-13.5,10.1s-13.5-4.5-13.5-10.1v-60.6c0-9.3-10.1-16.8-22.5-16.8h-71.8
c-7.4,0-13.5-4.5-13.5-10.1c0-5.6,6.1-10.1,13.5-10.1h71.8C302.6,94.8,324.7,111.4,324.8,131.9z"/>
</svg>)

export const EnfantPateModule = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 504 504" pace="preserve">
  <path d="M470.7,160.5c-13.8,0.5-26.3,8.6-32.3,21.1c-6.1,11.1-9.4,23.5-9.6,36.2v-162c0-10-5.2-19.4-13.7-24.7
c-8.5-5.4-19.1-6-28.2-1.8c0-16.2-13.1-29.3-29.3-29.3c-16.2,0-29.3,13.1-29.3,29.3c-9.1-4.3-19.7-3.7-28.2,1.7
c-8.5,5.4-13.6,14.7-13.7,24.8v15.4c-11.2-5.3-24.5-3-33.3,5.7c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1-0.1-0.1-0.2-0.2-0.2
c-8.8-8.8-22.1-11-33.3-5.7V55.8c0-10.1-5.2-19.4-13.7-24.8c-8.5-5.4-19.1-6-28.2-1.7c-0.7-15.7-13.6-28-29.3-28
c-15.7,0-28.6,12.3-29.3,28c-9.1-4.3-19.7-3.6-28.2,1.7C82.2,36.4,77,45.8,77,55.8v162c-0.2-12.7-3.5-25.1-9.6-36.2
c-6-12.5-18.5-20.6-32.3-21.1c-7.2,0-14.1,3.1-18.8,8.5c-4.8,5.4-7,12.6-6.1,19.7l24.9,148.4v4.8c0,25.5,9,50.2,25.3,69.7l5,5.9
C72.9,426.6,77,438,77,449.8v37.4c0,9.3,7.5,16.8,16.8,16.8h108.9c9.3,0,16.8-7.5,16.8-16.8v-37.4c0-11.7,4.1-23.1,11.6-32.1l5-6
c7-8.5,12.7-18,16.9-28.1c4.2,10.2,9.9,19.7,16.9,28.1l5,5.9c7.5,9.1,11.6,20.4,11.6,32.2v37.4c0,9.3,7.5,16.8,16.8,16.8h108.9
c9.3,0,16.8-7.5,16.8-16.8v-37.4c0-11.7,4.1-23.1,11.6-32.1l5-6c16.3-19.6,25.3-44.3,25.3-69.7v-4.8l25-149
c0.7-7.1-1.6-14.1-6.4-19.4C484.6,163.5,477.8,160.5,470.7,160.5z M290.5,285c12,7.7,25.9,12,40.2,12.4c10.1,0,20.1-2.6,28.8-7.6
c13.8,20.2,14.1,46.7,0.8,67.2c-8,12.9-22.8,25-40.1,20.3c-17.1-5.7-32.5-15.5-44.9-28.6c-14.7-13.4-29.9-27.2-53.3-27.2
c-0.7,0-1.4,0.1-2.1,0.3c-2.6,0.7-63.2,15.8-79.6-31.6c-7.2-20.7-6.1-38.5,3-51.3c6.2-8.5,15.2-14.4,25.5-16.8
c27.2-3.4,44.3,5,51,24.9c1.5,4.4,6.2,6.8,10.6,5.3c4.4-1.5,6.8-6.2,5.3-10.6c-4.9-16.2-17.5-29-33.8-33.9c1.5-1.7,3.1-3.4,4.5-5.2
c11.3-13.2,24-28.2,59.5-24.8c36.3,3.5,46.7,26.7,59.9,56.1c6.2,15,13.9,29.2,23.1,42.6c-9,4.5-26.1,8.4-49.8-5.9
c-2.6-1.6-5.8-1.7-8.5-0.2c-2.7,1.5-4.3,4.2-4.4,7.3C286.2,280.6,287.8,283.4,290.5,285L290.5,285z M303.2,55.8
c0-6.9,5.6-12.6,12.6-12.6c6.9,0,12.6,5.6,12.6,12.6v145c-6.1-11.2-14.7-20.8-25.1-28V55.8z M264.9,88.8c3.6-3.6,9-4.7,13.7-2.7
c4.7,2,7.8,6.6,7.8,11.6V165c-6.1-2-12.4-3.3-18.8-3.9c-2.2-0.2-4.3-0.3-6.3-0.4v-63C261.2,94.4,262.6,91.2,264.9,88.8z M231.9,85.1
c3.3,0,6.5,1.3,8.9,3.7c2.4,2.4,3.7,5.6,3.7,8.9v63.5c-8.8,1-17.3,3.6-25.1,7.8V97.7c0-3.3,1.3-6.5,3.7-8.9
C225.4,86.5,228.6,85.1,231.9,85.1z M190.1,43.2c3.3,0,6.5,1.3,8.9,3.7c2.4,2.4,3.7,5.6,3.7,8.9v126c-3.3,3.4-6.2,6.7-8.9,9.8
c-6.9,8.1-10.8,12.4-16.2,12.5V55.8C177.5,48.9,183.1,43.2,190.1,43.2z M223.2,400.9l-5.1,6c-10,12-15.5,27.2-15.5,42.9v37.4H93.7
v-37.4c0-15.7-5.5-30.9-15.5-43l-5-5.9c-13.8-16.6-21.3-37.4-21.3-59v-5.5c0-0.5,0-0.9-0.1-1.4l-25-148.6c-0.2-2.4,0.5-4.7,2.1-6.5
c1.6-1.8,3.8-2.8,6.2-2.8c7.8,0.5,14.7,5.4,17.8,12.6c4.8,9,7.4,19.1,7.3,29.3c0,0.9,0.1,1.8,0.4,2.6l16.8,50.3
c1.3,3.9,5.2,6.3,9.3,5.6c4.1-0.7,7-4.2,7-8.3V55.8c0-4.5,2.4-8.6,6.3-10.9c3.9-2.2,8.7-2.2,12.6,0c3.9,2.2,6.3,6.4,6.3,10.9v146.6
c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4V30.7c0-6.9,5.6-12.6,12.6-12.6c6.9,0,12.6,5.6,12.6,12.6v176.3
c-12.5,3.8-23.4,11.5-31,22.1c-8.7,12.2-16.6,33.6-5.2,66.5c17,49,71.2,49.4,98.5,42.7c7.6,0.2,15,2.6,21.4,6.8
C243.8,365.5,236.3,385.2,223.2,400.9z M454.1,335.1c-0.1,0.5-0.1,0.9-0.1,1.4v5.5c0,21.5-7.5,42.4-21.3,58.9l-5.1,6
c-10,12-15.5,27.2-15.5,42.9v37.4H303.2v-37.4c0-15.7-5.5-30.9-15.5-43l-5-5.9c-9.7-11.7-16.4-25.7-19.4-40.7l0.9,0.8
c14.3,14.9,32.1,26,51.7,32.3c4,1.1,8.1,1.7,12.2,1.7c19.6-1,37.2-12,46.6-29.3c14.9-24,19.6-62.7-5.5-90.9
c-9.9-11.9-18-25.1-24-39.4V30.7c0-6.9,5.6-12.6,12.6-12.6c6.9,0,12.6,5.6,12.6,12.6v188.5c0,4.6,3.8,8.4,8.4,8.4
c4.6,0,8.4-3.8,8.4-8.4V55.8c0-6.9,5.6-12.6,12.6-12.6c6.9,0,12.6,5.6,12.6,12.6v213.6c0,4.1,3,7.6,7,8.3s8-1.7,9.3-5.6l16.8-50.3
c0.3-0.9,0.4-1.7,0.4-2.6c0-10.2,2.5-20.3,7.3-29.3c3.1-7.2,10-12.1,17.8-12.6c2.4,0,4.6,1,6.2,2.8c1.5,1.6,2.3,3.7,2.2,5.9
L454.1,335.1z"/>
</svg>
)
export const EnfantPienture = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <circle cx="32.6" cy="23.1" r="0.9" />
  <path d="M32.8,27.1c-0.5-0.1-1,0.3-1.1,0.8c-0.3,1.7-1.7,3.1-3.9,3.8c-2.3,0.7-5.5,0.5-7.5-1.7
			C20,29.7,19.4,29.6,19,30c-0.4,0.3-0.4,0.9-0.1,1.3c1.1,1.2,2.7,2.1,4.5,2.4c0.6,0.1,1.3,0.2,1.9,0.2c1,0,2-0.2,3-0.4
			c2.9-0.9,4.8-2.9,5.2-5.3C33.6,27.7,33.3,27.2,32.8,27.1z"/>
  <path d="M45.7,18.9c-1.7-2-4-3.2-6.8-3.7c2.7-1.8,5-3.6,6.7-5.2c2.5-2.4,3.4-4.1,2.7-5.3c-0.8-1.4-3.1-1.4-7.1,0
			c-3.4,1.2-7.7,3.2-12.1,5.7c-0.8,0.4-1.5,0.9-2.2,1.3c-0.5-1.5-0.2-3.3,1-4.8c0.9-1.1,1.1-2.6,0.5-3.8c-0.6-1.2-1.9-2-3.5-2h0
			C19,1.2,13.5,3.4,9.1,7.5C4.7,11.6,2,17,1.5,22.7c-0.6,6.9,1.6,13.4,6.2,18.4c4.5,4.9,10.9,7.7,17.5,7.7c3.6,0,6.9-0.7,10-1.9
			c2.8-1.2,5.2-2.9,7.3-5c1.9-2,3.5-4.3,4.5-6.8c1-2.4,1.6-4.9,1.6-7.3C48.7,24.2,47.7,21.2,45.7,18.9z M26.8,13.9
			c1-0.6,2-1.2,3-1.8c4-2.3,8-4.2,11.3-5.4c3.6-1.3,5-1.2,5.4-1c0,0.2-0.3,1.2-2.6,3.3c-2,1.8-4.8,3.9-8.1,6c-1,0.6-2.1,1.3-3.2,1.9
			c-1.5,0.9-3,1.7-4.4,2.4c-0.3-0.8-0.7-1.7-1.1-2.5c-0.4-0.8-0.9-1.5-1.5-2.1C26,14.4,26.4,14.1,26.8,13.9z M26.6,20.1
			c-2.6,1.2-5,2.2-7,2.7c-0.1-0.5-0.3-0.9-0.5-1.4c-0.2-0.4-0.5-0.8-0.9-1.1c1.4-1.4,3.5-3,5.9-4.6c0.6,0.6,1,1.3,1.5,2
			C26,18.5,26.3,19.2,26.6,20.1z M46.8,27.7c-0.1,9.2-8.4,19.2-21.6,19.2c-6.1,0-12-2.6-16.1-7.1c-4.2-4.6-6.3-10.6-5.7-17
			C4.3,11.9,13.9,3.1,24.7,3.1h0c0.9,0,1.6,0.3,1.8,0.9c0.3,0.5,0.1,1.2-0.3,1.8c-1.7,2.1-2.1,4.7-1.1,6.9c-0.5,0.3-1,0.6-1.5,1
			c0,0,0,0,0,0c-3,2-5.5,4-7.1,5.6c-1.3-0.4-2.6-0.3-3.8,0.4c-1.9,1.1-4.5,6.3-5,7.3c-0.1,0.3-0.1,0.6,0,0.9
			c0.2,0.3,0.4,0.4,0.7,0.5c0.5,0,2,0.1,3.6,0.1c2,0,4.2-0.2,5.2-0.8c1.1-0.7,1.9-1.8,2.2-3c2.3-0.6,5.3-1.8,8.5-3.3
			c1.8-0.9,3.7-1.9,5.5-2.9c0.9-0.5,1.9-1.1,2.8-1.7c0,0,0,0,0,0C44.1,17,46.8,22.6,46.8,27.7z M17.8,23.9c-0.1,0.9-0.6,1.8-1.4,2.2
			c-0.9,0.5-3.9,0.6-6.4,0.5c1.1-2.2,2.7-4.8,3.6-5.3c0.8-0.5,1.8-0.5,2.7-0.1c0.5,0.2,0.9,0.6,1.1,1.1
			C17.7,22.8,17.9,23.4,17.8,23.9z"/>
  <path d="M17.7,7c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7S19.8,7,17.7,7z M17.7,12.5
			c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9S18.8,12.5,17.7,12.5z"/>
  <path d="M13.1,31.9c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7C16.8,33.6,15.2,31.9,13.1,31.9z
			 M13.1,37.5c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9C15,36.7,14.1,37.5,13.1,37.5z"/>
  <path d="M22.4,37.5c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7S24.4,37.5,22.4,37.5z M22.4,43.1
			c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9C24.3,42.3,23.4,43.1,22.4,43.1z"/>
  <path d="M33.5,35.6c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7S35.6,35.6,33.5,35.6z M33.5,41.2
			c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9C35.4,40.4,34.6,41.2,33.5,41.2z"/>
  <path d="M41,26.4c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7S43,26.4,41,26.4z M41,31.9
			c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9S42,31.9,41,31.9z"/>
</svg>)
export const EnfantDanse = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M9.9,10.2c0,2.7,2.2,5,5,5s5-2.2,5-5c0-1.4-0.6-2.7-1.6-3.6c0.9-0.2,1.6-1.1,1.6-2.1c0-1-0.8-1.9-1.8-2.1
 C17.8,1.6,17,1,16,1c-0.4,0-0.8,0.1-1.2,0.4C14.5,1.1,14.1,1,13.7,1c-0.9,0-1.7,0.6-2,1.4c-1,0.2-1.8,1-1.8,2.1
 c0,1,0.7,1.8,1.6,2.1C10.5,7.5,9.9,8.7,9.9,10.2z M18.4,10.2c0,2-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5
 S18.4,8.2,18.4,10.2z M12,5.2c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.6-0.2C12.9,3.5,13,3.3,13,3.1
 c0,0,0,0,0,0c0-0.4,0.3-0.7,0.7-0.7c0.2,0,0.5,0.1,0.6,0.3C14.4,2.9,14.6,3,14.8,3c0.2,0,0.5-0.1,0.6-0.3c0.1-0.2,0.4-0.3,0.6-0.3
 c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0c0,0.2,0.1,0.4,0.2,0.6c0.2,0.1,0.4,0.2,0.6,0.2c0,0,0.1,0,0.1,0c0.4,0,0.7,0.3,0.7,0.7
 s-0.3,0.7-0.7,0.7L12,5.2L12,5.2z"/>
  <path d="M22.3,18.4h-2.7c-0.3-1.1-1.3-1.9-2.5-1.9h-4.7c-1.2,0-2.2,0.8-2.5,1.9c-4.8,0.3-8.6,4.3-8.6,9.2
 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7c0-4.1,3.1-7.4,7.1-7.8v5.6c-0.9,1.1-1.4,2.5-1.4,4v4.8c0,0.4,0.3,0.7,0.7,0.7h2.1V38
 c0,0.4-0.3,0.7-0.7,0.7H4.1c-0.3,0-0.6,0.2-0.7,0.5l-0.9,2.8c-0.1,0.4,0.1,0.8,0.4,0.9C3,43,3,43,3.1,43c0.3,0,0.6-0.2,0.7-0.5
 l0.8-2.4h5.9c1.2,0,2.1-1,2.1-2.1V35h4.3v12.7c0,0.3,0.2,0.6,0.5,0.7l2.8,0.9c0.1,0,0.1,0,0.2,0c0.3,0,0.6-0.2,0.7-0.5
 c0.1-0.4-0.1-0.8-0.4-0.9l-2.4-0.8V35h2.1c0.4,0,0.7-0.3,0.7-0.7v-4.8c0-1.5-0.5-2.9-1.4-4v-2.8h2.6c1.2,0,2.1-1,2.1-2.1
 S23.5,18.4,22.3,18.4z M9.8,33.6v-1.5c0.8-0.1,1.5-0.4,2.1-0.8c0.8,0.6,1.8,0.9,2.8,0.9s2-0.3,2.8-0.9c0.6,0.4,1.4,0.7,2.1,0.8v1.5
 H9.8z M18.5,26.2c0.8,0.9,1.2,2.1,1.2,3.3v1.1c-0.6-0.1-1.2-0.4-1.7-0.8c-0.3-0.2-0.7-0.2-0.9,0c-0.7,0.6-1.5,0.9-2.4,0.9
 c-0.9,0-1.7-0.3-2.4-0.9c-0.3-0.2-0.7-0.2-0.9,0c-0.5,0.4-1,0.7-1.7,0.8v-1.1c0-1.2,0.4-2.4,1.2-3.3c0.1-0.1,0.2-0.3,0.2-0.5v-6.6
 c0-0.7,0.5-1.2,1.2-1.2h4.7c0.7,0,1.2,0.5,1.2,1.2v2.1h-2.1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h2.1v3.1
 C18.3,25.9,18.4,26.1,18.5,26.2z M22.3,21.3h-2.6v-1.4h2.6c0.4,0,0.7,0.3,0.7,0.7S22.7,21.3,22.3,21.3z"/>
  <path d="M46.9,39.2c-0.1-0.3-0.4-0.5-0.7-0.5h-6.4c-0.4,0-0.7-0.3-0.7-0.7v-6c0.9-0.9,1.4-2.1,1.4-3.5v-8.8
 c4.8-0.4,8.5-4.3,8.5-9.2c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7c0,4.1-3.2,7.5-7.2,7.8c-0.3-1.1-1.3-1.9-2.5-1.9h-4.7
 c-1.2,0-2.2,0.8-2.5,1.9H28c-1.2,0-2.1,1-2.1,2.1s1,2.1,2.1,2.1h2.6v5.9c0,1.3,0.5,2.6,1.4,3.5v15.1L29.6,48
 c-0.4,0.1-0.6,0.5-0.4,0.9c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,0.1,0,0.2,0l2.8-0.9c0.3-0.1,0.5-0.4,0.5-0.7V33.1
 c0.6,0.3,1.4,0.5,2.1,0.5s1.5-0.2,2.1-0.5v5c0,1.2,1,2.1,2.1,2.1h5.9l0.8,2.4c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,0.1,0,0.2,0
 c0.4-0.1,0.6-0.5,0.4-0.9L46.9,39.2z M28,21.3c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h2.6v1.4H28z M34.1,21.3H32v-2.1
 c0-0.7,0.5-1.2,1.2-1.2h4.7c0.7,0,1.2,0.5,1.2,1.2v8.7H32v-5.2h2.1c0.4,0,0.7-0.3,0.7-0.7S34.5,21.3,34.1,21.3z M32.1,29.3H39
 c-0.3,1.6-1.8,2.8-3.5,2.8C33.8,32.1,32.4,30.9,32.1,29.3z"/>
  <path d="M35.5,15.1c2.7,0,5-2.2,5-5s-2.2-5-5-5s-5,2.2-5,5S32.8,15.1,35.5,15.1z M35.5,6.6c2,0,3.5,1.6,3.5,3.5
 s-1.6,3.5-3.5,3.5c-2,0-3.5-1.6-3.5-3.5S33.6,6.6,35.5,6.6z"/>
</svg>
)
export const EnfantPiscine = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M47.4,37.7c-2.8-0.6-5.7-0.3-8.2,0.9c-2.7,1.3-6,1.3-8.7,0c0,0,0,0-0.1,0C27,37,23,37,19.5,38.7
   c-2.8,1.3-5.9,1.3-8.7,0c-1.7-0.8-3.6-1.2-5.5-1.2c-0.9,0-1.9,0.1-2.8,0.3c-0.7,0.2-1.1,0.9-1,1.6c0.2,0.7,0.9,1.1,1.6,1
   c2.2-0.5,4.5-0.2,6.5,0.7c1.7,0.8,3.6,1.2,5.5,1.2s3.7-0.4,5.5-1.3c2.8-1.3,6-1.3,8.7,0c0,0,0,0,0.1,0c3.4,1.6,7.5,1.6,10.9,0
   c2-1,4.3-1.2,6.5-0.7c0.7,0.2,1.4-0.3,1.6-1C48.6,38.6,48.1,37.9,47.4,37.7z"/>
  <path d="M47.4,31.5c-2.8-0.6-5.7-0.3-8.2,0.9c-0.3,0.2-0.7,0.3-1,0.4V6.6c0-2.8-2.2-5-5-5s-5,2.2-5,5
   c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4v6H21.8v-6c0-2.8-2.2-5-5-5s-5,2.2-5,5
   c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4v25.8c0,0,0,0.1,0,0.1
   c-2.7,1.2-5.7,1.1-8.4-0.1c-1.7-0.8-3.6-1.2-5.5-1.2c-0.9,0-1.9,0.1-2.8,0.3c-0.7,0.2-1.1,0.9-1,1.6c0.2,0.7,0.9,1.1,1.6,1
   c2.2-0.5,4.5-0.2,6.5,0.7c1.7,0.8,3.6,1.2,5.5,1.2c1.9,0,3.7-0.4,5.5-1.2c2.8-1.3,6-1.3,8.7,0c0,0,0,0,0.1,0
   c3.4,1.6,7.5,1.6,10.9,0c2-1,4.3-1.2,6.5-0.7c0.7,0.2,1.4-0.3,1.6-1C48.6,32.3,48.1,31.6,47.4,31.5z M35.6,33.3
   c-1.7,0.1-3.5-0.2-5.1-0.9c0,0,0,0-0.1,0c-2.7-1.3-5.8-1.6-8.7-0.8v-5.7h13.8V33.3z M35.6,23.3H21.8v-8h13.8V23.3z"/>
  <path d="M47.4,44c-2.8-0.6-5.7-0.3-8.2,0.9c-2.7,1.3-6,1.3-8.7,0c0,0,0,0-0.1,0c-3.5-1.6-7.4-1.6-10.9,0
   c-1.3,0.6-2.8,1-4.3,1c-1.5,0-3-0.3-4.4-1c-1.7-0.8-3.6-1.2-5.5-1.2c-0.9,0-1.9,0.1-2.8,0.3c-0.7,0.2-1.1,0.9-1,1.6
   c0.2,0.7,0.9,1.1,1.6,1c2.2-0.5,4.5-0.2,6.5,0.7c1.7,0.8,3.6,1.2,5.5,1.2c1.9,0,3.8-0.4,5.5-1.2c2.8-1.3,5.9-1.3,8.7,0
   c0,0,0,0,0.1,0c1.7,0.8,3.6,1.2,5.4,1.2c1.9,0,3.8-0.4,5.5-1.2c2-1,4.3-1.2,6.5-0.7c0.7,0.2,1.4-0.3,1.6-1
   C48.6,44.9,48.1,44.2,47.4,44z"/>
</svg>
)
export const EnfantLecture = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M47.6,10.9C47.6,10.9,47.6,10.9,47.6,10.9L47.6,10.9h-3.1V9.9c0-0.4-0.3-0.8-0.7-0.9
   c-2.1-0.6-4.4-0.8-6.6-0.8c-3.7,0-8.6,0.8-12.3,4.6c-3.7-3.8-8.7-4.6-12.3-4.6c-2.2,0-4.4,0.3-6.6,0.8C5.7,9.1,5.4,9.4,5.4,9.9v1
   H2.4c-0.5,0-0.9,0.4-0.9,0.9V41c0,0.5,0.4,0.9,0.9,0.9c0.2,0,0.3,0,0.4-0.1c0.1,0,9.2-5,22-1.8h0.1H25c0.1,0,0.1,0,0.2,0
   c12.8-3.2,21.9,1.7,22,1.8c0.3,0.2,0.6,0.2,0.9,0c0.3-0.2,0.5-0.5,0.5-0.8V11.8C48.6,11.3,48.2,10.9,47.6,10.9z M3.3,39.5V12.7
   h2.2v22.9c0,0.5,0.4,0.9,0.9,0.9c0,0,0.1,0,0.1,0c1.9-0.3,3.8-0.4,5.7-0.5c2.6,0,5.3,0.4,7.8,1.2C14.3,36.6,8.6,37.4,3.3,39.5z
    M12.2,34.3c-1.7,0-3.3,0.1-5,0.3v-24C9,10.2,10.8,10,12.7,10c3.4,0,8.1,0.8,11.4,4.5l0,22.7C22.2,36,18.5,34.3,12.2,34.3z
    M25.9,14.4c3.3-3.7,8-4.5,11.4-4.5c1.8,0,3.6,0.2,5.4,0.6v24c-1.6-0.2-3.3-0.3-4.9-0.3c-6.2,0-9.9,1.7-11.9,2.9V14.4z M46.7,39.5
   c-5.3-2.2-11.1-2.9-16.8-2.3c2.5-0.8,5.2-1.2,7.8-1.2c1.9,0,3.8,0.2,5.7,0.4c0.5,0.1,1-0.3,1-0.8c0,0,0-0.1,0-0.1V12.7h2.2
   L46.7,39.5z"/>
</svg>
)
export const EnfantActiviteManuelle = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M30.4,14.9L30.4,14.9c-0.2,0.5,0.1,1.1,0.6,1.2c0.1,0,0.2,0,0.3,0c0.4,0,0.8-0.3,0.9-0.7l0,0
c0.2-0.5-0.1-1.1-0.6-1.2C31.1,14.1,30.5,14.4,30.4,14.9z"/>
  <path d="M12.2,34.4C12.2,34.4,12.2,34.4,12.2,34.4c-2.4-1.4-5.4-0.6-6.8,1.8c-0.7,1.1-0.8,2.5-0.5,3.8
c0.3,1.3,1.2,2.4,2.3,3c0.8,0.5,1.6,0.7,2.5,0.7c1.7,0,3.4-0.9,4.3-2.5C15.4,38.8,14.6,35.8,12.2,34.4L12.2,34.4z M12.4,40.2
c-0.8,1.4-2.7,1.9-4.1,1.1c-0.7-0.4-1.2-1.1-1.4-1.8c-0.2-0.8-0.1-1.6,0.3-2.3c0.6-1,1.6-1.5,2.6-1.5c0.5,0,1,0.1,1.5,0.4
C12.7,36.9,13.2,38.8,12.4,40.2L12.4,40.2z"/>
  <path d="M37.2,34.4C37.2,34.4,37.2,34.4,37.2,34.4c-2.4-1.4-5.4-0.6-6.8,1.8c-1.4,2.4-0.6,5.4,1.8,6.8
c0.8,0.4,1.6,0.7,2.5,0.7c1.7,0,3.4-0.9,4.3-2.5C40.4,38.8,39.6,35.8,37.2,34.4z M37.4,40.2c-0.8,1.4-2.7,1.9-4.1,1.1
c-1.4-0.8-1.9-2.7-1.1-4.1c0.6-1,1.6-1.5,2.6-1.5c0.5,0,1,0.1,1.5,0.4C37.7,36.9,38.2,38.8,37.4,40.2z"/>
  <path d="M46.8,42.4c-1.1-0.1-2.2-0.6-3-1.3c0.6-2.4,0.3-4.9-1-7c-2.4-4.2-7.6-5.8-11.9-3.9l-2.3-4l2.2-6.5
c0.2-0.5-0.1-1.1-0.6-1.2c-0.5-0.2-1.1,0.1-1.2,0.6l-2.3,6.9l0,0l-0.5,1.4c-1.5,4.5-2.3,5.2-6.1,8.5L20,35.9
c-0.1,0.1-0.2,0.2-0.2,0.2l-3.6,6.3c-1,1.7-2.6,2.9-4.5,3.5c-1.9,0.5-3.9,0.2-5.6-0.7c-1.7-1-2.9-2.6-3.5-4.5
C2,38.7,2.3,36.7,3.3,35c2-3.5,6.6-4.8,10.1-2.7c0.5,0.3,1.1,0.1,1.3-0.4l8.3-14.3c0,0,0,0,0,0l8.3-14.3c0.1-0.1,0.2-0.2,0.3-0.1
c1.6,0.9,1.6,3,1.1,4.6l-1.1,3.1c-0.2,0.5,0.1,1.1,0.6,1.2c0.5,0.2,1.1-0.1,1.2-0.6l1.1-3.1c0.4-1.3,0.5-2.6,0.3-3.8
c-0.3-1.4-1.1-2.4-2.3-3.1c-1-0.6-2.4-0.2-3,0.8l-7.4,12.9L14.8,2.2c-0.6-1-1.9-1.4-3-0.8c-1.2,0.7-2,1.8-2.3,3.1
C9.3,5.7,9.4,7,9.8,8.3l6,17.9l-2.3,4C9.2,28.2,4,29.8,1.6,34c-1.3,2.2-1.6,4.7-0.9,7.1c0.6,2.4,2.2,4.4,4.4,5.7
c1.4,0.8,3,1.3,4.7,1.3c0.8,0,1.6-0.1,2.4-0.3c2.4-0.6,4.4-2.2,5.7-4.4l3.5-6.1l0,0c0.3-0.3,0.6-0.5,0.8-0.7
c0.3,0.2,0.6,0.5,0.9,0.7l3.5,6.1c1.3,2.2,3.3,3.7,5.7,4.4c0.8,0.2,1.6,0.3,2.4,0.3c1.6,0,3.2-0.4,4.7-1.3c0.2-0.1,0.4-0.3,0.7-0.4
c1.7,1.3,3.7,2.2,5.9,2.4c0.1,0,0.3,0,0.4,0c1.6,0,3-1.2,3.2-2.8C49.8,44.2,48.6,42.6,46.8,42.4L46.8,42.4z M11.7,7.7
c-0.5-1.6-0.5-3.6,1.1-4.6c0.1-0.1,0.3,0,0.3,0.1l8,13.9l-4,6.9L11.7,7.7z M38.5,45.1c-1.7,1-3.7,1.3-5.6,0.7
c-1.9-0.5-3.5-1.7-4.5-3.5l-3.6-6.3c-0.1-0.1-0.1-0.2-0.2-0.2c-0.3-0.2-0.5-0.5-0.8-0.7c2-1.9,2.9-3.2,4.1-6.6l1.9,3.3
c0.3,0.5,0.9,0.6,1.3,0.4c3.5-2,8.1-0.8,10.1,2.7c1,1.7,1.3,3.7,0.7,5.6C41.4,42.5,40.2,44.1,38.5,45.1L38.5,45.1z M47.7,45.8
c-0.1,0.7-0.8,1.2-1.5,1.1c-1.7-0.2-3.3-0.8-4.6-1.8c0.6-0.6,1.1-1.4,1.5-2.2c1,0.7,2.2,1.2,3.5,1.4C47.3,44.4,47.8,45.1,47.7,45.8z
"/>
  <path d="M22.1,26.5L22.1,26.5c-0.6,0-1,0.4-1,1c0,0.5,0.4,1,1,1h0c0.5,0,1-0.4,1-1C23.1,26.9,22.7,26.5,22.1,26.5z" />
</svg>)
export const EnfantAutre = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M32.1,26.7c1.6-0.7,3.2-1.3,4.8-1.6c0.5-0.1,0.7-0.5,0.6-1c-0.1-0.5-0.5-0.7-1-0.6c-1.8,0.4-3.7,1-5.5,1.9
     c-1-1.2-2.2-2.5-3.5-3.8c-1.3-1.3-2.7-2.6-4-3.7c1.1-1.4,2-3,2.7-4.7c1.1-2.7,1.6-5.8,1.6-9.2c0-0.5-0.4-0.8-0.8-0.8
     c-0.5,0-0.8,0.4-0.8,0.8c0,5.2-1.3,9.6-4,12.9c-0.5-0.4-1-0.7-1.4-1c-2.5-1.7-4-2.1-4.8-1.3c0,0,0,0,0,0l0,0l0,0
     c-0.2,0.2-0.3,0.5-0.4,0.8L3.2,44.8c-0.1,0.3-0.1,0.7,0.2,0.9C3.6,45.9,3.8,46,4,46c0.1,0,0.2,0,0.3-0.1l0,0l29.4-12.3
     c0.3,0,0.5-0.2,0.7-0.3c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0.8-0.8,0.4-2.3-1.3-4.8C32.9,27.9,32.5,27.3,32.1,26.7z
      M9.8,40c-0.2,1.1-0.6,1.8-0.8,2.1l-3.5,1.5l3.5-8.4C9.8,36.9,10.1,38.5,9.8,40z M15,37.2c-0.3,1.9-1.2,2.9-1.5,3.1l-2.2,0.9
     c0.5-1.7,0.6-4.5-1.3-8.1l2.5-6C15.1,32,15.3,35.3,15,37.2z M17.9,38.4l-1.8,0.8c0.2-0.4,0.3-0.9,0.4-1.5
     c0.7-3.4-0.4-7.6-3.2-12.6l0.9-2.2c0.7,0.9,1.5,2.1,1.9,2.9c0.1,0.3,0.4,0.5,0.8,0.5c0.1,0,0.2,0,0.3-0.1
     c0.4-0.2,0.6-0.7,0.4-1.1c-0.5-1.1-1.7-2.9-2.7-3.9l1.4-3.3c0.2,0.4,0.5,0.9,0.9,1.5c0.3,0.4,0.5,0.7,0.8,1.1
     c2.9,4.3,2.8,8.8,2.2,11.7C19.7,35.5,18.4,37.8,17.9,38.4z M24.4,35.7l-4,1.7c0.6-1.3,1.2-2.9,1.5-4.7c0.4-2.1,0.6-4.8-0.2-7.7
     c0.4,0.4,0.8,0.8,1.2,1.3c1.3,1.3,2.5,2.4,3.7,3.4C26.6,33.6,24.8,35.4,24.4,35.7z M27.3,34.5c0.5-0.9,0.8-2.1,1-3.6
     c0.5,0.4,1,0.7,1.5,1.1c0.5,0.4,1,0.7,1.5,0.9L27.3,34.5z M30.2,30.2c-1.8-1.3-4-3.1-6-5.2c-2.1-2.1-3.9-4.2-5.2-6
     c-1.2-1.8-1.6-2.7-1.7-3c0.4,0.1,1.3,0.4,3,1.7c0.3,0.2,0.5,0.4,0.8,0.6c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.3,0.9,0,1.2
     c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.2,0.3-0.3c1.3,1,2.6,2.3,3.9,3.6c1.1,1.1,2.2,2.3,3.1,3.4
     c-0.2,0.1-0.3,0.2-0.5,0.3c-0.4,0.2-0.5,0.7-0.3,1.1c0.2,0.3,0.4,0.4,0.7,0.4c0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.5-0.3,0.7-0.4
     c0.4,0.5,0.7,0.9,1,1.3c1.2,1.8,1.6,2.7,1.7,3C32.9,31.8,32,31.5,30.2,30.2z"/>
  <path d="M18.3,27.3c-0.2-0.4-0.7-0.6-1.1-0.4c-0.4,0.2-0.6,0.7-0.4,1.1c0.1,0.3,0.4,0.5,0.8,0.5c0.1,0,0.2,0,0.3-0.1
     C18.3,28.3,18.5,27.8,18.3,27.3C18.3,27.3,18.3,27.3,18.3,27.3z"/>
  <path d="M34.4,16.1c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c1.9-1.9,4.9-2.7,7.1-2.9c0.5,0,0.8-0.4,0.8-0.9
     c0-0.5-0.4-0.8-0.9-0.8c-2.5,0.2-6,1.2-8.2,3.4C34.1,15.3,34.1,15.8,34.4,16.1z"/>
  <path d="M45.4,11.7C45.4,11.7,45.3,11.7,45.4,11.7c-0.5-0.1-1,0.1-1.1,0.6c-0.1,0.5,0.2,0.9,0.6,1l0,0
     c0.1,0,0.1,0,0.2,0c0.4,0,0.7-0.2,0.8-0.6C46.1,12.3,45.8,11.8,45.4,11.7z"/>
  <path d="M9.3,10.2h0.8V11c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8v-0.8h0.8c0.5,0,0.8-0.4,0.8-0.8
     s-0.4-0.8-0.8-0.8h-0.8V7.7c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8v0.8H9.3c-0.5,0-0.8,0.4-0.8,0.8S8.9,10.2,9.3,10.2z"/>
  <path d="M28.9,18.3h0.8v0.8c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-0.8h0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8
     h-0.8v-0.8c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v0.8h-0.8c-0.5,0-0.8,0.4-0.8,0.8S28.4,18.3,28.9,18.3z"/>
  <path d="M40.5,38.1h-0.8v-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8v0.8h-0.8c-0.5,0-0.8,0.4-0.8,0.8
     c0,0.5,0.4,0.8,0.8,0.8H38v0.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8v-0.8h0.8c0.5,0,0.8-0.4,0.8-0.8
     C41.4,38.5,41,38.1,40.5,38.1z"/>
  <path d="M35.8,8.2c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5S34.4,8.2,35.8,8.2z M35.8,4.8
     c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8C35,5.2,35.3,4.8,35.8,4.8z"/>
  <path d="M41,17.7c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S42.4,17.7,41,17.7z M41,21
     c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8C41.9,20.7,41.5,21,41,21z"/>
  <path d="M19.8,11.2c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5S18.4,11.2,19.8,11.2z M19.8,7.8
     c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8C18.9,8.2,19.3,7.8,19.8,7.8z"/>
  <path d="M40.7,27.8c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8S40.7,28.2,40.7,27.8z" />
  <path d="M31.2,11.1c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8
     C30.4,10.7,30.8,11.1,31.2,11.1z"/>
  <path d="M42.4,33.2c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8C43.3,33.6,42.9,33.2,42.4,33.2z"
  />
  <path d="M14.8,5.7c0.5,0,0.8-0.4,0.8-0.8S15.3,4,14.8,4C14.4,4,14,4.4,14,4.8S14.4,5.7,14.8,5.7z" />
</svg>
)

export const EnfantFievre = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M40.1,7.4v2h-7.8v-2H40.1z M36.8,11.7h-4.5v2h4.5V11.7z M32.3,18.1h7.8v-2h-7.8V18.1z M36.8,20.5h-4.5v2h4.5
 V20.5z M32.3,26.9h7.8v-2h-7.8V26.9z M33.5,38.3c0,5.6-4.6,10.2-10.2,10.2s-10.2-4.6-10.2-10.2c0-3.6,1.9-6.9,5-8.8v-23
 c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1v23C31.6,31.4,33.5,34.7,33.5,38.3z M31.5,38.3c0-3.1-1.7-5.9-4.5-7.3l-0.5-0.3V6.5
 c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1v24.2L19.7,31c-2.8,1.4-4.5,4.2-4.5,7.3c0,4.5,3.7,8.2,8.2,8.2S31.5,42.8,31.5,38.3z
  M29.9,38.3c0,3.6-2.9,6.5-6.5,6.5c-3.6,0-6.5-2.9-6.5-6.5c0-2.9,2-5.5,4.8-6.3l0.4-0.1V19.6h2.6v12.4L25,32
 C27.9,32.8,29.9,35.4,29.9,38.3z M23.7,34c-0.2-0.7-0.8-1.1-1.5-1c-2.5,0.6-4.2,2.7-4.2,5.2c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3
 c0-1.3,0.9-2.4,2.2-2.7C23.4,35.4,23.9,34.7,23.7,34z"/>
</svg>
)
export const EnfantVomi = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M30.8,36.2c0.6,0,1-0.4,1-1s-0.4-1-1-1c-1.1,0-2,0.6-2.5,1.4c-0.6-0.3-1.4-0.4-2.2-0.4s-1.6,0.1-2.2,0.4
 c-0.5-0.8-1.5-1.4-2.5-1.4c-0.6,0-1,0.4-1,1s0.4,1,1,1c0.6,0,1,0.4,1,1s-0.4,1-1,1c-0.6,0-1,0.4-1,1s0.4,1,1,1
 c1.5,0,2.7-1.1,2.9-2.5c0,0,0-0.1,0-0.1c0.2-0.1,0.8-0.4,1.8-0.4s1.6,0.3,1.8,0.4c0,0,0,0.1,0,0.1c0.2,1.4,1.5,2.5,2.9,2.5
 c0.6,0,1-0.4,1-1s-0.4-1-1-1c-0.6,0-1-0.4-1-1S30.2,36.2,30.8,36.2z"/>
  <circle cx="18.5" cy="27.2" r="2" />
  <circle cx="32.5" cy="27.2" r="2" />
  <path d="M46.4,20.5c-0.1-0.3-0.1-0.5-0.2-0.8c-0.1-0.3-0.1-0.5-0.2-0.8c-0.1-0.4-0.3-0.8-0.4-1.2
 c-0.1-0.2-0.1-0.4-0.2-0.6c-0.2-0.5-0.4-0.9-0.6-1.4c-0.1-0.1-0.1-0.2-0.1-0.3c-0.2-0.5-0.5-0.9-0.7-1.4c-0.1-0.1-0.1-0.2-0.2-0.3
 c-0.2-0.4-0.5-0.8-0.7-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-4-5.3-10.4-8.6-17.5-8.6c-8.3,0-15.6,4.8-19.3,12
 c-0.1,0.1-0.1,0.2-0.2,0.4c-0.2,0.3-0.3,0.7-0.5,1c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.2,0.6-0.3,1
 c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.1,0.5-0.2,0.7c-1.8,1-3.1,3.1-3.1,5.2c0,2.2,1.3,4.1,3.2,5C6.2,40.4,14.9,47.2,25,47.2
 c10.1,0,18.8-6.8,21.3-16.5c1.9-0.9,3.2-2.8,3.2-5C49.5,23.6,48.2,21.5,46.4,20.5z M5.8,20c0.1-0.3,0.1-0.5,0.2-0.8
 c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.3,0.3-0.7,0.4-1c0.1-0.1,0.1-0.3,0.2-0.4c3.2-6.7,9.9-11,17.8-11
 c6.1,0,11.6,2.6,15.2,6.9c0,0,0,0,0,0c0.3,0.4,0.6,0.8,0.9,1.1c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.2,0.3,0.5,0.5,0.8
 c0.2,0.3,0.3,0.5,0.5,0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.3,0.2,0.6,0.3,0.9
 c0.1,0.2,0.2,0.5,0.2,0.7c0.1,0.3,0.2,0.6,0.2,0.9c0,0.2,0.1,0.3,0.1,0.5c-4.1,1.3-7.1-1.6-9-4.4c-0.3-0.5-0.9-0.8-1.5-0.9
 c-0.6-0.1-1.2,0.1-1.7,0.5c-9.3,7.4-22.8,5.5-26.4,4.7C5.7,20.3,5.8,20.1,5.8,20z M45.1,29c-0.3,0.1-0.6,0.4-0.7,0.7
 C42.4,38.8,34.4,45.2,25,45.2c-9.4,0-17.4-6.4-19.5-15.5c-0.1-0.3-0.3-0.6-0.7-0.7c-1.4-0.5-2.4-1.8-2.4-3.3c0-1.4,0.9-2.8,2.1-3.4
 c1.2,0.3,4.8,1,9.4,1c5.9,0,13.3-1.2,19.3-6c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.1c3.3,4.9,7.5,6.7,11.8,5
 c1.2,0.6,2,2.1,2,3.4C47.5,27.1,46.5,28.5,45.1,29z"/>
</svg>)
export const EnfantToux = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M24.8,46.5c-0.2,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.2,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3
c0.2,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.2-0.1-0.5-0.3-0.7C25.3,46.6,25.1,46.5,24.8,46.5z"/>
  <path d="M48.4,43.5l-0.7-0.7V39c0-3-2.2-5.7-5.1-6.3l-5.3-1.1c-0.1-1.7-0.5-3.3-1.2-4.8l0.3-0.5
c0.1-0.2,0.2-0.5,0.1-0.8c-0.1-0.3-0.3-0.5-0.5-0.6L33.8,24c-0.4-0.2-0.7-0.3-1-0.5c0.8-1.4,1.2-2.9,1.2-4.6v-7
c2-1.4,3.3-3.7,3.3-6.3v-4c0-0.5-0.4-0.9-0.9-0.9H23.6c-4.4,0-7.9,3.6-7.9,7.9V19c0,1.6,0.4,3.2,1.2,4.6c-0.3,0.2-0.7,0.3-1,0.5
L13.6,25c-0.3,0.1-0.4,0.3-0.5,0.6c-0.1,0.3,0,0.5,0.1,0.8l1.3,2c0.9,1.4,2.6,2.1,4.2,1.8c-0.2,0.1-0.4,0.2-0.7,0.3L7,32.7
c-3,0.6-5.1,3.3-5.1,6.3v8.4c0,0.5,0.4,0.9,0.9,0.9h18.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9H3.8V39c0-2.2,1.5-4,3.6-4.5
l11-2.3c0.2,0,0.3-0.1,0.4-0.1c1.6,1.5,3.7,2.2,5.9,2.2c0.3,0,0.7,0,1-0.1l1.6,1.6c1.1,1.1,2.6,1.7,4.2,1.7h0l0.6,0l0.6,0.6
c0,0,0,0,0,0c0,0,0,0,0,0l8.2,8.2H28.7c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h14.4c0,0,0.1,0,0.1,0c0.2,0,0.5-0.1,0.7-0.3
c0.4-0.4,0.4-1,0-1.3l-9.1-9.1l2.6-2.6l9.8,9.8c0.4,0.4,1,0.4,1.3,0C48.7,44.5,48.7,43.9,48.4,43.5z M45.9,39v2l-7.2-7.2l3.5,0.7
C44.3,35,45.9,36.9,45.9,39z M17.5,8.6c0-3.4,2.7-6.1,6.1-6.1h11.8v3.1c0,3.2-2.6,5.8-5.8,5.8h-12V8.6z M17.5,19v-5.6h12
c0.9,0,1.7-0.2,2.5-0.4V19c0,1.2-0.3,2.4-0.9,3.5c-0.9-0.7-1.7-1.6-2.4-2.6c-0.9-1.3-2.3-2.2-4-2.2s-3.1,0.8-4,2.2
c-0.7,1-1.5,1.9-2.4,2.7C17.8,21.4,17.5,20.2,17.5,19z M16.1,27.4l-0.7-1.1l1.2-0.5c2.4-1,4.4-2.7,5.8-4.9c0.5-0.8,1.4-1.3,2.4-1.3
s1.9,0.5,2.4,1.3c1.1,1.7,2.6,3.1,4.3,4.1c-0.2,0.3-0.4,0.6-0.5,0.9c-0.7-0.4-1.5-0.6-2.3-0.5c-1.2,0.1-2.3,0.7-3.1,1.6l-0.9,1.2
c-0.2,0.2-0.3,0.4-0.4,0.7c-0.2,0-0.4-0.1-0.6-0.2L23,28.1c-1.2-0.7-2.8-0.7-4,0C18,28.7,16.7,28.3,16.1,27.4z M21.3,29.5
c0.3,0,0.5,0.1,0.8,0.3l0.8,0.4c0.3,0.2,0.7,0.3,1,0.4c0,0.7,0.1,1.3,0.4,1.9c-1.4-0.1-2.7-0.6-3.8-1.4
C20.8,30.6,21.1,30.1,21.3,29.5z M33.4,36.3l-0.2-0.2c-0.2-0.2-0.4-0.3-0.7-0.3c0,0,0,0,0,0l-1,0c0,0,0,0,0,0
c-1.1,0-2.1-0.4-2.9-1.2l-2.3-2.3c-0.8-0.8-0.9-2.2-0.2-3.1l0.9-1.2c0.4-0.5,1-0.9,1.7-0.9c0.7,0,1.3,0.2,1.8,0.7l1.3,1.3
c0.4,0.4,1,0.4,1.4,0.1c0.4-0.3,0.5-0.9,0.3-1.4l-0.8-1.4C32.7,26.2,33,26,33.1,26c0.1,0,0.3-0.2,0.4,0c0.3,0.4,0.5,0.8,0.7,1.2
c0,0,0,0.1,0,0.1c0.8,1.6,1.2,3.4,1.2,5.2l0,0.4c0,0.2,0.1,0.5,0.3,0.7l0.2,0.2L33.4,36.3z"/>
</svg>)
export const EnfantBlessure = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M45.2,4.8c-2.1-2.1-5-3.3-8-3.3c-3,0-5.9,1.2-8,3.3L4.9,29.1c-4.4,4.4-4.4,11.6,0,16C6,46.1,7.2,47,8.6,47.5
   c0.5,0.2,1.1,0,1.3-0.6c0.2-0.5,0-1.1-0.6-1.3c-1.1-0.5-2.1-1.1-3-2c-1.7-1.7-2.7-4.1-2.7-6.5s1-4.8,2.7-6.5L30.6,6.3
   c1.7-1.7,4.1-2.7,6.5-2.7c2.5,0,4.8,1,6.5,2.7c1.7,1.7,2.7,4.1,2.7,6.5s-1,4.8-2.7,6.5L19.5,43.6c-2.1,2.1-4.9,3-7.8,2.6
   c-0.6-0.1-1.1,0.3-1.2,0.9c-0.1,0.6,0.3,1.1,0.9,1.2c0.5,0.1,1,0.1,1.5,0.1c3,0,5.8-1.2,8-3.3l24.2-24.2
   C49.6,16.4,49.6,9.2,45.2,4.8z"/>
  <path d="M33,21.8L28.2,17c-1.5-1.5-3.9-1.5-5.3,0L17,22.8c-1.5,1.5-1.5,3.9,0,5.3l4.8,4.8c0.2,0.2,0.5,0.3,0.7,0.3
   c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1.1,0-1.5l-4.8-4.8c-0.7-0.7-0.7-1.8,0-2.4l5.8-5.8c0.7-0.7,1.8-0.7,2.4,0l4.8,4.8
   c0.7,0.7,0.7,1.8,0,2.4l-5.8,5.8c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l5.8-5.8C34.5,25.7,34.5,23.3,33,21.8z"/>
  <circle cx="12.9" cy="28.3" r="1" />
  <circle cx="15.8" cy="31.3" r="1" />
  <circle cx="18.7" cy="34.2" r="1" />
  <circle cx="28.4" cy="12.8" r="1" />
  <circle cx="31.4" cy="15.7" r="1" />
  <circle cx="34.3" cy="18.6" r="1" />
  <circle cx="37.2" cy="21.6" r="1" />
  <circle cx="31.4" cy="9.9" r="1" />
  <circle cx="34.3" cy="12.8" r="1" />
  <circle cx="37.2" cy="15.7" r="1" />
  <circle cx="40.1" cy="18.6" r="1" />
  <circle cx="34.3" cy="7" r="1" />
  <circle cx="37.2" cy="9.9" r="1" />
  <circle cx="40.1" cy="12.8" r="1" />
  <circle cx="43" cy="15.7" r="1" />
  <circle cx="7.1" cy="34.2" r="1" />
  <circle cx="10" cy="37.1" r="1" />
  <circle cx="12.9" cy="40" r="1" />
  <circle cx="15.8" cy="42.9" r="1" />
  <circle cx="7.1" cy="40" r="1" />
  <circle cx="10" cy="42.9" r="1" />
  <circle cx="10" cy="31.3" r="1" />
  <circle cx="12.9" cy="34.2" r="1" />
  <circle cx="15.8" cy="37.1" r="1" />
  <circle cx="18.7" cy="40" r="1" />
  <circle cx="40.1" cy="7" r="1" />
  <circle cx="43" cy="9.9" r="1" />
  <circle cx="21.7" cy="37.1" r="1" />
</svg>)
export const EnfantBoutons = ({ width, height, classCSS }) => (<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width={width} className={classCSS} fill="#0B45EF" height={height} viewBox="0 0 50 50" pace="preserve">
  <path d="M42.3,21.1v-1.7c0-4.6-1.8-8.9-5.1-12.2c-2.5-2.5-5.5-4.1-8.9-4.7c-1.1-0.2-2.2-0.3-3.3-0.3
 c-4.2,0-8.3,1.5-11.5,4.4c-0.3,0.3-0.3,0.7-0.1,1c0.3,0.3,0.7,0.3,1,0.1c2.9-2.6,6.6-4,10.5-4c1,0,2,0.1,3,0.3
 c3.1,0.6,5.9,2.1,8.2,4.4c3,3,4.6,7,4.6,11.2v1.7c-9.5-0.1-15.7-2.2-19.3-3.9c-3.2-1.5-5-3.2-5.6-3.9c-0.2-0.2-0.5-0.3-0.8-0.2
 c-0.3,0.1-0.5,0.4-0.5,0.7c0,1.4-0.7,3-1.9,4.4c-1,1.1-2.3,2.1-3.7,2.7v-1.4c0-3.4,1.1-6.7,3.1-9.4c0.2-0.3,0.2-0.7-0.1-1
 c-0.3-0.2-0.7-0.2-1,0.1c-2.2,3-3.4,6.5-3.4,10.3v1.7c-0.1,0-0.3,0-0.4,0c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1
 c0.2,0,0.4,0,0.6,0c1.3,8.3,8.4,14.6,17.1,14.6c1.1,0,2.2-0.1,3.3-0.3c0.6-0.1,1.2-0.3,1.8-0.5c0.4-0.1,0.6-0.5,0.5-0.9
 c-0.1-0.4-0.5-0.6-0.9-0.5c-0.5,0.2-1.1,0.3-1.7,0.4c-1,0.2-2,0.3-3,0.3c-8.7,0-15.9-7.1-15.9-15.9v-8.3c1.8-0.7,3.4-1.8,4.7-3.2
 c1.1-1.2,1.8-2.5,2.1-3.8c0.9,0.8,2.5,2,4.9,3.2c3.7,1.8,10.2,4,20,4.1v8.1c0,3-0.8,5.9-2.4,8.4c-1.5,2.5-3.7,4.4-6.3,5.7
 c-0.3,0.2-0.5,0.6-0.3,0.9c0.1,0.2,0.4,0.4,0.6,0.4c0.1,0,0.2,0,0.3-0.1c2.8-1.4,5.2-3.6,6.9-6.2c1.2-2,2.1-4.2,2.4-6.5
 c0.1,0,0.1,0,0.2,0c3.4,0,6.1-2.7,6.1-6.1C48.4,23.8,45.6,21.1,42.3,21.1z M7.3,31.9c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7
 c0.1,0,0.3,0,0.4,0v2.8c-1.1,0-2.4,0.3-3.1,1.8c-0.2,0.4,0,0.8,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.5-0.2,0.6-0.4
 c0.4-0.9,1.2-1,1.8-0.9v3.9c0,0.4,0,0.8,0,1.3C7.6,31.9,7.5,31.9,7.3,31.9z M42.2,31.9C42.2,31.9,42.2,31.9,42.2,31.9
 c0-0.4,0-0.9,0-1.3v-3.9c0.6,0,1.4,0,1.8,0.9c0.1,0.3,0.4,0.4,0.6,0.4c0.1,0,0.2,0,0.3-0.1c0.4-0.2,0.5-0.6,0.4-0.9
 c-0.6-1.5-2-1.8-3.1-1.8v-2.8c2.6,0,4.7,2.1,4.7,4.7C47,29.8,44.8,31.9,42.2,31.9z"/>
  <path d="M17.1,24.7v3.1c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-3.1c0-0.4-0.3-0.7-0.7-0.7
 C17.4,24,17.1,24.3,17.1,24.7z"/>
  <path d="M32.9,27.9v-3.1c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v3.1c0,0.4,0.3,0.7,0.7,0.7
 C32.6,28.6,32.9,28.2,32.9,27.9z"/>
  <path d="M29,38.5c0.2,0,0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-1c-2.5-2.5-6.6-2.5-9.1,0c-0.3,0.3-0.3,0.7,0,1
 c0.3,0.3,0.7,0.3,1,0c2-2,5.1-2,7.1,0C28.6,38.5,28.8,38.5,29,38.5z"/>
  <path d="M37.1,26.7c0.2,0.2,0.5,0.4,0.8,0.3c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.1-0.6-0.3-0.7c-0.3-0.1-0.6-0.1-0.8,0.1
 C36.9,26,36.9,26.4,37.1,26.7z"/>
  <path d="M18.4,21.1c0.3,0,0.6-0.2,0.7-0.5c0.1-0.3,0-0.6-0.3-0.8c-0.5-0.4-1.2,0.1-1.1,0.7
 C17.8,20.9,18.1,21.1,18.4,21.1z"/>
  <path d="M12.3,30.3c-0.3-0.5-1.2-0.3-1.3,0.3c0,0.3,0.1,0.6,0.4,0.7c0.3,0.1,0.6,0.1,0.8-0.1
 C12.5,30.9,12.5,30.5,12.3,30.3z"/>
  <path d="M20.3,34.7c0.2-0.2,0.3-0.6,0.1-0.8c-0.1-0.3-0.4-0.4-0.7-0.3c-0.3,0.1-0.5,0.3-0.6,0.6
 c-0.1,0.3,0.1,0.6,0.3,0.7C19.7,34.9,20.1,34.9,20.3,34.7z"/>
  <path d="M27.7,26.9c0.2,0.2,0.5,0.4,0.7,0.3c0.3-0.1,0.5-0.3,0.5-0.6c0-0.6-0.7-1-1.2-0.6
 C27.6,26.2,27.5,26.6,27.7,26.9z"/>
  <path d="M22.6,30.2c0.3,0.5,1.2,0.3,1.3-0.3c0.1-0.6-0.7-1-1.2-0.6C22.5,29.5,22.4,29.9,22.6,30.2z" />
  <path d="M13.7,24c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.3-0.5,0.2-0.8c-0.1-0.3-0.4-0.5-0.7-0.5c-0.3,0-0.6,0.2-0.7,0.4
 C13.3,23.4,13.4,23.8,13.7,24z"/>
  <path d="M33.2,39.6c-0.3,0.1-0.5,0.3-0.6,0.6c0,0.3,0.1,0.6,0.3,0.7c0.6,0.3,1.2-0.2,1-0.8
 C33.8,39.7,33.5,39.5,33.2,39.6z"/>
  <path d="M18.7,43.3c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.3-0.5,0.2-0.8c-0.2-0.5-1-0.5-1.3,0
 C18.3,42.7,18.4,43.1,18.7,43.3z"/>
  <path d="M26.5,42.8c-0.3,0.1-0.5,0.3-0.6,0.6c0,0.3,0.1,0.6,0.4,0.7c0.6,0.3,1.2-0.4,0.9-0.9
 C27.1,42.9,26.8,42.7,26.5,42.8z"/>
  <path d="M13.5,37.9c0.1,0.3,0.4,0.4,0.7,0.4c0.3,0,0.5-0.2,0.6-0.5c0.2-0.6-0.5-1.2-1-0.8
 C13.5,37.2,13.4,37.5,13.5,37.9z"/>
  <path d="M33.3,32.5c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.3,0.5-0.2,0.8c0.1,0.3,0.4,0.5,0.7,0.4c0.3,0,0.6-0.2,0.6-0.5
 C33.7,33,33.6,32.7,33.3,32.5z"/>
</svg>)










export function getStatusToString(statut, time) {
  return _.isEmpty(statut) ? "" : statut == "PRESENT" ?
    "Arrivé" + " à " + moment(time).format('HH') + "h" + moment(time).format('mm')
    : statut == "PARTI" ?
      "Parti" + " à " + moment(time).format('HH') + "h" + moment(time).format('mm')
      : statut == "ATTENDU" ? "Attendu"
        : "Absent"

}
export function getEtatSanteToString(ObjetSante, time) {

  return ObjetSante === "FIEVRE" ?
    "Fièvre"
    : ObjetSante == "VOMI" ?
      "Vomi"
      : ObjetSante == "TOUX" ?
        "Toux"
        : ObjetSante == "BLESSURE" ?
          "Blessure"
          : ObjetSante == "BOUTONS" ?
            "BOUTONS"
            : ObjetSante == "AUTRE" ?
              "AUTRE"
              : ""

}

export function getPetitCoinToString(categorie) {

  return categorie === "PETITE_COMMISSION" ?
    "Selles"
    : "Pipi"


}

export function getActiviteToString(statut, time) {
  return statut == "PATE_A_MODELER" ?
    "PATE_A_MODELER" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
    : statut == "PEINTURE" ?
      "PEINTURE" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
      : statut == "DANSE" ?
        "DANSE" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
        : statut == "SORTIE" ?
          "SORTIE" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
          : statut == "PISCINE" ?
            "PISCINE" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
            : statut == "LECTURE" ?
              "LECTURE" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
              : statut == "ACTIVITE_MANUELLE" ? "ACTIVITE_MANUELLE" + " à " + moment(time).format('h') + "h" + moment(time).format('mm')
                : "Rien"
}


export function getRepasToString(type, time) {
  return type == "REPAS_PEU" ?
    " À " + moment(time).format('h') + "h" + moment(time).format('mm')
    : type == "REPAS_CORRECTEMENT" ?
      " À " + moment(time).format('h') + "h" + moment(time).format('mm')
      : type == "REPAS_BEAUCOUP" ?
        " À " + moment(time).format('h') + "h" + moment(time).format('mm')

        : " À " + moment(time).format('h') + "h" + moment(time).format('mm')

}

export function getDiversification(type) {
  return type == "ENCOURS" ?
    "en cours"
    : type == "TERMIENR" ?
      "terminée"
      : "pas encore commencée"

}

//Converti time en foramt (HH h MM)
export function convTime(time) {

  return moment(time).format("HH[h]mm");

}
// Differance entre deux temps
export function deltaTime(time1, time2) {
  let now = moment(time1).format("DD/MM/YYYY HH:mm:ss");
  let then = moment(time2).format("DD/MM/YYYY HH:mm:ss");
  let ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"));
  let d = moment.duration(ms);
  let s = Math.floor(d.asHours()) + moment.utc(ms).format("[h]mm");
  return s;

}

//Fonction statuEnfant 
// export function enfantStatuSwitch(statut, size, classCSS) {
//   switch (statut) {
//     case "PRESENT":
//       return <EnfantPresent size={size} classCSS={classCSS} />;
//     case "ATTENDU":
//       return <EnfantAttendu size={size} classCSS={classCSS} />;
//     case "PARTI":
//       return <EnfantParti size={size} classCSS={classCSS} />;
//     case "ABSENT":
//       return <EnfantAbsent size={size} classCSS={classCSS} />;
//     case "ARRIVEE":
//       return <EnfantPresent size={size} classCSS={classCSS} />;
//     case "DEPART":
//       return <EnfantParti size={size} classCSS={classCSS} />;
//     default:
//       return "";
//   }
// }
//Fonction objet Sante dans la nav Current
export function iconSanteSwitch(objetSante, size, classCSS) {
  switch (objetSante) {
    case "FIEVRE":
      return <EnfantFievre size={size} classCSS={classCSS} />;
    case "VOMI":
      return <EnfantVomi size={size} classCSS={classCSS} />;
    case "TOUX":
      return <EnfantToux size={size} classCSS={classCSS} />;
    case "BLESSURE":
      return <EnfantBlessure size={size} classCSS={classCSS} />;
    case "BOUTONS":
      return <EnfantBoutons size={size} classCSS={classCSS} />;
    case "AUTRE":
      return <EnfantAutre size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}
//Fonction objet Sante dans la nav Current

export function getObjetSanteToString(etatSante) {

  return etatSante === "RIEN_DE_GRAVE" ?
    "Rien de grave"
    : etatSante == "A_SURVEILLER" ?
      "À surveiller"
      : etatSante == "INQUIETANT" ?
        "Inquiétant"
        : ""

}
export function iconRepaSwitch(type, size, classCSS) {
  switch (type) {
    case "PEU":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "CORRECTEMENT":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "BEAUCOUP":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "BIBERON":
      return <EnfantBiberon size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}
export function RepaSwitch(type) {
  return type === "PEU" ?
    "Peu mangé"
    : type == "CORRECTEMENT" ?
      "Correctement mangé"
      : type == "BEAUCOUP" ?
        "Beaucoup mangé"
        : ""
}

export function iconActiviteSwitch(typeActivite, size, classCSS) {
  switch (typeActivite) {
    case "PATE_A_MODELER":
      return <EnfantPateModule size={size} classCSS={classCSS} />;
    case "PEINTURE":
      return <EnfantPienture size={size} classCSS={classCSS} />;
    case "DANSE":
      return <EnfantDanse size={size} classCSS={classCSS} />;
    case "SORTIE":
      return <EnfantSortie size={size} classCSS={classCSS} />;
    case "PISCINE":
      return <EnfantPiscine size={size} classCSS={classCSS} />;
    case "LECTURE":
      return <EnfantLecture size={size} classCSS={classCSS} />;
    case "ACTIVITE_MANUELLE":
      return <EnfantActiviteManuelle size={size} classCSS={classCSS} />;
    case "PARTI":
      return <EnfantParti size={size} classCSS={classCSS} />;
    case "ARRIVEE":
      return <EnfantArrive size={size} classCSS={classCSS} />;
    case "DEPART":
      return <EnfantParti size={size} classCSS={classCSS} />;
    case "AUTRE":
      return <EnfantAutre size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}

//Function switch all MINI icons 
// export function MINI_iconEVENTSwitch(event, size, classCSS, handleClick) {
//   let typeEvent = event.typeEvent;
//   switch (typeEvent) {
//     case "ARRIVEE":
//       return <EnfantArriveMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "DEPART":
//       return <EnfantPartiMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "SIESTE":
//       return <EnfantSiesteMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "REPAS_PEU":
//       return <EnfantRepasMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "REPAS_CORRECTEMENT":
//       return <EnfantRepasMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "REPAS_BEAUCOUP":
//       return <EnfantRepasMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "BIBERON":
//       return <EnfantBiberonMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "NEXT_BIBERON":
//       return <EnfantBiberonMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "PETITE_COMMISSION":
//       return <EnfantPetitCoinMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "GROSSE_COMMISSION":
//       return <EnfantPetitCoinMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "INCIDENT":
//       return <EnfantEventSanteMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "FIEVRE":
//       return <EnfantFievreMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "VOMI":
//       return <EnfantVomiMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "TOUX":
//       return <EnfantTouxMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "BLESSURE":
//       return <EnfantBlessureMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "BOUTONS":
//       return <EnfantBoutonsMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "PATE_A_MODELER":
//       return <EnfantPateModuleMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "PEINTURE":
//       return <EnfantPientureMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "DANSE":
//       return <EnfantDanseMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "SORTIE":
//       return <EnfantSortieMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "PISCINE":
//       return <EnfantPiscineMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "LECTURE":
//       return <EnfantLectureMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "ACTIVITE_MANUELLE":
//       return <EnfantActiviteManuelleMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     case "ACTIVITE":
//       return <EnfantAutreActiviteMINI key={event.idEvent} size={size} classCSS={classCSS} handleClick={handleClick} event={event} />;
//     default:
//       return ""
//   }
// }

//Function switch all icons 
export function iconEVENTSwitch(event, width, height, classCSS) {
  let typeEvent = event.typeEvent;
  switch (typeEvent) {
    case "ARRIVEE":
      return <EnfantArrive width={width} height={height} classCSS={classCSS} />;
    case "DEPART":
      return <EnfantParti width={width} height={height} classCSS={classCSS} />;
    case "SIESTE":
      return <EnfantSieste width={width} height={height} classCSS={classCSS} />;
    case "REPAS_PEU":
      return <EnfantRepas width={width} height={height} classCSS={classCSS} />;
    case "REPAS_CORRECTEMENT":
      return <EnfantRepas width={width} height={height} classCSS={classCSS} />;
    case "REPAS_BEAUCOUP":
      return <EnfantRepas width={width} height={height} classCSS={classCSS} />;
    case "BIBERON":
      return <EnfantBiberon width={width} height={height} classCSS={classCSS} />;
    case "NEXT_BIBERON":
      return <EnfantBiberon width={width} height={height} classCSS={classCSS} />;
    case "PETITE_COMMISSION":
      return <EnfantPetitCoin width={width} height={height} classCSS={classCSS} />;
    case "GROSSE_COMMISSION":
      return <EnfantPetitCoin width={width} height={height} classCSS={classCSS} />;
    case "INCIDENT":
      return <EnfantEventSante width={width} height={height} classCSS={classCSS} />;
    case "FIEVRE":
      return <EnfantFievre width={width} height={height} classCSS={classCSS} />;
    case "VOMI":
      return <EnfantVomi width={width} height={height} classCSS={classCSS} />;
    case "TOUX":
      return <EnfantToux width={width} height={height} classCSS={classCSS} />;
    case "BLESSURE":
      return <EnfantBlessure width={width} height={height} classCSS={classCSS} />;
    case "BOUTONS":
      return <EnfantBoutons width={width} height={height} classCSS={classCSS} />;
    case "PATE_A_MODELER":
      return <EnfantPateModule width={width} height={height} classCSS={classCSS} />;
    case "PEINTURE":
      return <EnfantPienture width={width} height={height} classCSS={classCSS} />;
    case "DANSE":
      return <EnfantDanse width={width} height={height} classCSS={classCSS} />;
    case "SORTIE":
      return <EnfantSortie width={width} height={height} classCSS={classCSS} />;
    case "PISCINE":
      return <EnfantPiscine width={width} height={height} classCSS={classCSS} />;
    case "LECTURE":
      return <EnfantLecture width={width} height={height} classCSS={classCSS} />;
    case "ACTIVITE_MANUELLE":
      return <EnfantActiviteManuelle width={width} height={height} classCSS={classCSS} />;
    case "ACTIVITE":
      return <EnfantAutre width={width} height={height} classCSS={classCSS} />;
    default:
      return ""
  }
}

//function switch all text 
export function textEVENTSwitch(event) {
  let typeEvent = event.typeEvent;
  switch (typeEvent) {
    case "ARRIVEE":
      return "Arrivée ";
    case "DEPART":
      return "Départ ";
    case "SIESTE":
      return "Sieste ";
    case "REPAS_PEU":
      return "Peu mangé ";
    case "REPAS_CORRECTEMENT":
      return "Correctement mangé ";
    case "REPAS_BEAUCOUP":
      return "Beaucoup mangé ";
    case "BIBERON":
      return event.quantite + " ml";
    case "NEXT_BIBERON":
      return "Prochain biberon ";
    case "PETITE_COMMISSION":
      return "Pipi ";
    case "GROSSE_COMMISSION":
      return "Selles ";
    case "INCIDENT":
      return "Incident ";
    case "FIEVRE":
      return "Fiévre ";
    case "VOMI":
      return "Vomi ";
    case "TOUX":
      return "Toux ";
    case "BLESSURE":
      return "Blessure ";
    case "BOUTONS":
      return "Boutons ";
    case "ACTIVITE":
      return "Activité ";
    case "PATE_A_MODELER":
      return "Pâte à modeler ";
    case "PEINTURE":
      return "Pienture ";
    case "DANSE":
      return "Danse ";
    case "SORTIE":
      return "Sortie ";
    case "PISCINE":
      return "Piscine ";
    case "LECTURE":
      return "Lecture ";
    case "ACTIVITE_MANUELLE":
      return "Activités manuelles ";
    case "AUTRE":
      return "Autre ";
    default:
      return ""
  }
}

export function toUpperCaseFirst(string) {
  if (!_.isEmpty(string)) {
    string.toLowerCase();
    return (string.charAt(0).toUpperCase() + string.substring(1));
  }
}

export function toLowerCaseFirst(string) {
  if (!_.isEmpty(string)) return string.toLowerCase();
}

export function equalName(alimentA, alimentB) { return (alimentA === alimentB) }

//function aliments libelle
export function matchAfterUrl(string) {
  const regex = /aliments\/(.*)/;
  return string.match(regex)[1]
}
//function aliments libelle
export function toFrenchDays(string) {
  switch (string) {
    case "MONDAY":
      return "Lundi"
    case "TUESDAY":
      return "Mardi"
    case "WEDNESDAY":
      return "Mercredi"
    case "THURSDAY":
      return "Jeudi"
    case "FRIDAY":
      return "Vendredi"
    case "SATURDAY":
      return "Samedi"
    case "SUNDAY":
      return "Dimanche"
    default:
      return ""
  }
}